const WorldBorderList = {
  0: {
    1: {
      countryId: 1,
      countryBorder: [
        [[640,396],[642,397],[644,397],[644,398],[642,399],[639,399],[639,398]]
      ],
      countryCenter: { x: 641.5, y: 397.5 },
      countryName: 'Heard Is.',
    },
    2: {
      countryCenter: { x: 856, y: 218 },
      countryCode: 'GUM',
      countryId: 2,
      countryName: 'Guam',
    },
    3: {
      countryCenter: { x: 837, y: 227 },
      countryCode: 'PLW',
      countryId: 3,
      countryName: 'Palau',
    },
    4: {
      countryBorder: [
        [[633,142],[636,143],[637,143],[638,141],[640,141],[641,140],[641,138],[643,137],[643,136],[644,137],[645,137],[646,137],[648,138],[649,138],[651,137],[652,138],[652,136],[654,136],[654,135],[655,134],[656,134],[656,135],[657,135],[657,138],[659,139],[659,138],[660,138],[662,136],[663,137],[666,137],[667,138],[665,138],[664,138],[661,139],[659,139],[658,141],[659,142],[659,144],[658,145],[659,146],[658,147],[656,147],[657,149],[656,150],[655,152],[656,153],[655,154],[654,154],[652,154],[652,155],[650,155],[649,157],[649,159],[646,161],[644,160],[644,161],[642,161],[640,161],[635,160],[637,157],[637,155],[635,154],[634,152],[633,150],[634,148],[632,148],[633,146]]
      ],
      countryCenter: { x: 649.5, y: 147.5 },
      countryCode: 'AFG',
      countryId: 4,
      countryName: 'Afghanistan',
      labelCenter: { x: 645, y: 147.5 },
    },
    5: {
      countryBorder: [
        [[511,179],[502,185],[494,190],[491,192],[488,192],[488,190],[487,190],[485,189],[484,187],[476,181],[467,174],[457,167],[457,166],[457,163],[461,160],[464,160],[466,159],[467,158],[470,156],[470,154],[472,154],[473,153],[476,152],[477,151],[476,150],[475,147],[475,145],[474,143],[477,142],[479,141],[481,140],[483,139],[487,139],[492,138],[493,139],[495,138],[498,138],[499,138],[501,138],[500,140],[501,143],[500,145],[499,147],[499,149],[501,151],[501,152],[503,153],[504,158],[505,161],[505,162],[504,165],[505,166],[504,168],[505,170],[504,171],[505,173],[505,174],[506,176],[507,175],[510,177]],
      ],
      countryCenter: { x: 484, y: 165 },
      countryCode: 'DZA',
      countryId: 5,
      countryName: 'Algeria',
    },
    6: {
      countryBorder: [
        [[543,283],[543,285],[543,286],[543,287],[543,288],[538,288],[537,298],[539,301],[541,302],[536,304],[529,303],[528,302],[517,302],[516,302],[515,301],[513,301],[512,301],[510,302],[510,300],[511,297],[512,294],[512,293],[513,290],[513,289],[515,287],[516,286],[516,284],[516,282],[515,281],[514,279],[514,277],[515,275],[514,272],[513,270],[512,269],[512,268],[513,268],[514,268],[515,267],[523,267],[524,270],[524,271],[525,272],[526,274],[528,274],[529,273],[530,274],[530,273],[531,271],[533,271],[533,270],[534,270],[534,272],[537,272],[537,273],[538,275],[537,276],[538,278],[538,279],[538,283],[539,283],[540,283],[542,282]],
        [[512,267],[511,265],[512,263],[513,263],[514,264],[513,265],[513,267]]
      ],
      countryCenter: { x: 526.5, y: 285.5 },
      countryCode: 'AGO',
      countryId: 6,
      countryName: 'Angola',
    },
    7: {
      countryBorder: [
        [
          [317,198],
          { c: { x: 317, y: 198, label: { x: 322, y: 198.3, countryName: 'Antigua' } } },
        ],
        [
          [317,197],
          { c: { x: 317, y: 196, label: { x: 322.4, y: 196.2, countryName: 'Barbuda' } } },
        ]
      ],
      countryCode: 'ATG',
      countryId: 7,
    },
    8: {
      countryBorder: [
        [[330,414],[329,414],[327,414],[324,407],[325,409],[327,411],[331,413],[334,413],[334,415],[332,415]],
        [[316,317],[321,322],[324,322],[327,324],[330,325],[330,327],[328,331],[331,332],[334,333],[336,332],[338,330],[338,327],[339,327],[341,328],[341,331],[339,332],[338,334],[335,337],[332,341],[332,343],[332,346],[332,349],[332,350],[332,352],[332,353],[336,356],[336,358],[338,359],[338,361],[337,365],[333,366],[328,367],[326,367],[327,368],[327,371],[328,372],[326,373],[324,374],[321,373],[321,373],[322,376],[324,377],[325,376],[326,378],[324,379],[323,381],[323,384],[323,385],[321,385],[319,387],[319,389],[323,391],[325,392],[325,394],[323,396],[323,399],[321,401],[321,402],[322,405],[325,407],[324,406],[321,406],[316,406],[314,404],[313,402],[312,402],[310,401],[309,398],[310,396],[310,395],[310,393],[310,391],[309,387],[308,385],[309,384],[309,383],[307,383],[308,381],[306,380],[305,377],[305,376],[304,373],[303,370],[303,367],[304,366],[303,363],[302,360],[304,358],[303,356],[304,353],[303,350],[302,349],[300,344],[301,341],[300,338],[301,335],[302,333],[303,331],[302,329],[303,329],[302,323],[305,322],[305,319],[305,318],[307,315],[310,316],[312,318],[313,316],[316,316]]
      ],
      countryCenter: { x: 320.5, y: 361 },
      countryCode: 'ARG',
      countryId: 8,
      countryName: 'Argentina',
    },
    9: {
      countryBorder: [
        [[586,126],[589,125],[590,126],[591,127],[592,128],[592,129],[593,130],[594,131],[594,133],[592,131],[591,131],[590,130],[589,129],[587,128],[587,127]]
      ],
      countryCenter: { x: 590, y: 130 },
      countryCode: 'ARM',
      countryId: 9,
      countryName: 'Armenia',
    },
    10: {
      countryBorder: [
        [
          [835,373],[837,374],[838,373],[841,373],[842,373],[840,376],[838,377],[836,380],[836,379],[833,381],[831,381],[831,378],[832,376],[833,374],[834,372],
          { c: { x: 835.5, y: 376.5, label: { x: 835.5, y: 376.5, countryName: 'Tasmania' } } }
        ],
        [[859,291],[859,293],[861,292],[862,294],[863,295],[862,296],[863,299],[863,307],[866,308],[867,310],[869,311],[868,312],[869,314],[870,317],[871,316],[871,318],[872,317],[872,320],[873,322],[874,323],[876,326],[875,328],[875,330],[874,332],[874,334],[873,337],[872,338],[871,341],[870,343],[868,345],[866,348],[863,349],[861,352],[860,353],[858,356],[856,357],[854,359],[853,361],[852,362],[850,363],[847,364],[845,365],[843,366],[840,367],[839,366],[838,365],[839,364],[838,364],[834,367],[832,366],[831,365],[830,365],[828,364],[828,357],[826,357],[827,355],[827,353],[825,355],[823,356],[825,354],[826,352],[828,351],[828,349],[825,351],[823,352],[821,355],[820,354],[821,352],[820,350],[819,349],[820,348],[817,346],[816,346],[814,345],[809,345],[805,346],[802,347],[800,347],[796,348],[794,349],[793,351],[791,352],[782,352],[780,354],[779,353],[777,354],[776,355],[772,355],[770,353],[769,353],[770,351],[771,351],[772,350],[772,349],[774,347],[774,345],[773,342],[774,340],[774,336],[773,334],[773,327],[774,328],[775,329],[775,327],[774,325],[774,321],[775,321],[776,319],[776,317],[777,315],[777,317],[779,315],[781,314],[782,313],[785,312],[786,312],[789,311],[790,311],[791,310],[792,310],[793,310],[796,309],[798,308],[799,306],[800,304],[801,303],[801,302],[803,299],[804,302],[805,301],[805,300],[806,298],[807,299],[807,296],[809,295],[810,294],[811,293],[811,292],[812,293],[813,292],[814,292],[815,291],[817,293],[818,294],[820,294],[821,295],[821,293],[823,291],[824,290],[824,289],[825,287],[827,286],[828,287],[830,286],[831,285],[829,284],[830,283],[832,284],[833,285],[835,286],[836,286],[838,286],[839,286],[840,286],[841,285],[842,287],[841,288],[840,290],[839,290],[839,291],[838,292],[837,294],[837,295],[839,296],[841,297],[842,298],[843,300],[844,300],[845,301],[846,302],[848,303],[850,302],[851,300],[851,299],[852,297],[853,295],[853,293],[853,291],[854,289],[855,288],[854,287],[855,285],[856,284],[856,283],[857,282],[858,283],[858,285],[858,287],[859,288],[859,290]],
      ],
      countryCenter: { x: 822.5, y: 324.5 },
      countryCode: 'AUS',
      countryId: 10,
      countryName: 'Australia',
    },
    11: {
      countryBorder: [
        [[519,105],[519,106],[518,106],[518,109],[517,109],[515,109],[514,110],[512,110],[509,109],[508,108],[506,108],[506,109],[504,108],[503,108],[503,108],[502,108],[502,107],[503,106],[504,107],[504,106],[506,107],[508,106],[509,106],[510,107],[510,104],[511,103],[513,104],[514,102],[515,102],[517,103],[518,103],[519,103],[519,104]],
      ],
      countryCenter: { x: 514, y: 105 },
      countryCode: 'AUT',
      countryId: 11,
      countryName: 'Austria',
    },
    12: {
      countryBorder: [
        [[594,133],[592,132],[590,131],[590,130],[591,131],[592,131]],
        [[597,125],[598,124],[599,125],[601,127],[602,127],[603,128],[601,128],[601,132],[600,133],[601,134],[600,134],[598,133],[599,131],[598,130],[597,130],[594,133],[594,131],[593,130],[592,129],[592,128],[591,127],[591,127],[590,126],[589,125],[590,125],[592,126],[593,126],[593,125],[592,124],[592,123],[593,124],[595,125],[596,126]]
      ],
      countryCenter: { x: 598, y: 127 },
      countryCode: 'AZE',
      countryId: 12,
      countryName: 'Azerbaijan',
    },
    13: {
      countryBorder: [
        [[278,178],[277,178],[277,176],[276,175],[277,174],[278,174],[278,176]],
        [[279,169],[276,170],[276,169],[277,169],[279,169]],
        [[281,169],[280,172],[280,171],[280,170],[279,168],[279,168]],
      ],
      countryCenter: { x: 278.5, y: 173 },
      countryCode: 'BHS',
      countryId: 13,
      countryName: 'Bahamas',
    },
    14: {
      countryCenter: { x: 322, y: 210 },
      countryCode: 'BRB',
      countryId: 14,
      countryName: 'Barbados',
      labelCenter: { x: 327, y: 210 },
    },
    15: {
      countryBorder: [
        [[532,88],[534,88],[537,87],[537,85],[539,84],[538,83],[539,83],[542,82],[544,82],[545,83],[546,83],[548,83],[548,85],[550,87],[551,88],[552,89],[553,90],[550,90],[551,91],[552,93],[550,93],[549,94],[550,96],[549,95],[547,95],[546,95],[545,95],[544,95],[542,95],[540,94],[537,94],[536,94],[534,95],[533,95],[533,93],[532,92],[533,92],[533,90],[533,89]],
      ],
      countryCenter: { x: 542.5, y: 91 },
      countryCode: 'BLR',
      countryId: 15,
      countryName: 'Belarus',
    },
    16: {
      countryBorder: [
        [[245,196],[245,195],[246,195],[246,196],[247,194],[248,194],[248,197],[247,198],[248,198],[247,200],[246,200],[246,201],[245,202],[245,198]],
      ],
      countryCenter: { x: 246.5, y: 198 },
      countryCode: 'BLZ',
      countryId: 16,
      countryName: 'Belize',
      labelCenter: { x: 249, y: 198 },
    },
    17: {
      countryBorder: [
        [[487,231],[485,231],[484,229],[484,222],[483,221],[483,220],[482,219],[482,216],[483,216],[483,215],[485,214],[485,214],[486,213],[487,213],[489,214],[489,215],[490,217],[489,218],[489,219],[488,221],[487,222],[487,226]],
      ],
      countryCenter: { x: 486, y: 220 },
      countryCode: 'BEN',
      countryId: 17,
      countryName: 'Benin',
    },
    18: {
      countryBorder: [
        [[716,166],[717,167],[717,169],[715,169],[713,169],[711,169],[709,168],[708,167],[710,165],[711,164],[713,165],[714,165]],
      ],
      countryCenter: { x: 712.5, y: 167 },
      countryCode: 'BTN',
      countryId: 18,
      countryName: 'Bhutan',
    },
    19: {
      countryBorder: [
        [[305,318],[303,319],[302,314],[300,311],[300,308],[299,307],[298,305],[297,303],[298,299],[297,297],[297,296],[297,295],[298,293],[297,291],[297,288],[298,287],[295,283],[297,283],[299,283],[299,282],[301,281],[303,280],[306,279],[306,281],[306,282],[306,284],[309,287],[312,288],[314,289],[315,289],[316,290],[318,290],[320,291],[320,293],[321,294],[321,295],[320,295],[321,299],[326,299],[326,300],[326,302],[328,302],[329,304],[328,307],[328,308],[328,310],[327,310],[327,309],[325,308],[322,308],[318,309],[317,311],[317,313],[316,317],[316,316],[313,316],[312,318],[310,316],[307,315]],
      ],
      countryCenter: { x: 312, y: 299 },
      countryCode: 'BOL',
      countryId: 19,
      countryName: 'Bolivia',
    },
    20: {
      countryBorder: [
        [[525,114],[526,114],[525,116],[527,117],[526,118],[526,118],[525,119],[525,119],[524,121],[522,120],[521,119],[520,118],[519,117],[518,116],[517,115],[518,113],[519,114],[519,113],[520,113],[522,114],[524,114]],
      ],
      countryCenter: { x: 520, y: 117 },
      countryCode: 'BIH',
      countryId: 20,
      countryName: 'B & H.',
    },
    21: {
      countryBorder: [
        [[556,316],[552,318],[550,321],[549,323],[548,324],[547,324],[546,325],[546,326],[544,327],[542,327],[541,326],[540,326],[539,326],[538,328],[537,329],[535,330],[533,330],[533,329],[533,328],[532,325],[531,324],[531,315],[534,315],[534,305],[536,304],[540,303],[541,305],[543,303],[544,303],[545,303],[546,303],[547,305],[547,306],[548,308],[551,311],[552,311],[552,312],[553,314],[555,315]],
      ],
      countryCenter: { x: 543.5, y: 316.5 },
      countryCode: 'BWA',
      countryId: 21,
      countryName: 'Botswana',
    },
    22: {
      countryBorder: [
        [[332,341],[335,337],[338,334],[339,332],[341,331],[341,328],[339,327],[338,327],[339,325],[339,324],[339,322],[338,321],[337,322],[336,322],[335,321],[335,318],[334,317],[332,316],[331,317],[329,316],[328,312],[327,310],[328,310],[328,308],[328,307],[329,304],[328,302],[326,302],[326,300],[326,299],[321,299],[320,295],[321,295],[321,294],[320,293],[320,291],[318,290],[316,290],[315,289],[314,289],[312,288],[309,287],[306,284],[306,282],[306,281],[306,279],[303,280],[301,281],[299,282],[299,283],[297,283],[295,283],[294,283],[293,283],[293,278],[290,280],[288,280],[287,278],[285,278],[286,277],[284,275],[283,272],[284,272],[284,270],[285,270],[285,268],[286,267],[286,265],[289,263],[291,263],[291,262],[294,263],[295,254],[295,253],[294,251],[293,250],[293,248],[295,247],[295,248],[295,247],[294,246],[294,244],[299,244],[300,243],[300,244],[301,246],[301,246],[303,247],[305,247],[305,246],[307,246],[309,245],[309,244],[311,243],[311,242],[308,242],[308,240],[308,238],[307,237],[308,237],[310,237],[312,238],[312,237],[314,237],[317,236],[318,235],[318,234],[319,234],[320,234],[320,236],[321,236],[321,238],[320,239],[320,241],[321,243],[321,244],[322,246],[324,246],[324,245],[325,245],[326,244],[327,244],[328,244],[329,244],[330,244],[331,243],[330,243],[330,242],[332,242],[333,242],[334,243],[336,243],[336,242],[337,243],[337,243],[339,243],[340,242],[340,240],[342,237],[343,237],[344,239],[345,244],[346,244],[347,246],[344,249],[345,250],[350,250],[350,253],[352,251],[356,252],[360,254],[361,256],[361,258],[364,257],[369,258],[373,258],[377,261],[381,264],[383,265],[385,265],[386,266],[387,270],[387,272],[386,277],[385,279],[381,283],[380,286],[378,289],[377,289],[377,291],[377,297],[377,301],[376,303],[376,305],[375,309],[373,313],[373,316],[371,317],[370,319],[367,319],[363,320],[362,321],[359,322],[356,325],[354,328],[354,330],[355,332],[354,335],[354,336],[352,338],[350,343],[348,345],[347,347],[346,350],[345,351],[344,350],[345,348],[343,346],[341,345],[338,343],[337,343],[334,340]],
      ],
      countryCenter: { x: 335, y: 292.5 },
      countryCode: 'BRA',
      countryId: 22,
      countryName: 'Brazil',
    },
    23: {
      countryBorder: [
        [[783,236],[784,235],[787,233],[787,235],[787,237],[785,236],[785,237]],
      ],
      countryCenter: { x: 785, y: 235 },
      countryCode: 'BRN',
      countryId: 23,
      countryName: 'Brunei',
      labelCenter: { x: 779, y: 235 },
    },
    24: {
      countryBorder: [
        [[534,116],[535,118],[536,117],[538,118],[541,118],[542,117],[545,117],[547,118],[548,118],[547,119],[547,121],[548,123],[545,123],[543,124],[543,125],[541,125],[539,124],[537,125],[536,125],[535,123],[534,122],[534,122],[534,121],[534,120],[535,119],[534,118],[533,117]],
      ],
      countryCenter: { x: 540.5, y: 120.5 },
      countryCode: 'BGR',
      countryId: 24,
      countryName: 'Bulgaria',
    },
    25: {
      countryBorder: [
        [[472,220],[470,220],[469,220],[468,221],[467,220],[466,219],[465,218],[465,217],[466,215],[466,214],[468,212],[468,210],[469,209],[470,209],[471,209],[472,208],[474,207],[474,206],[477,204],[478,204],[479,205],[481,205],[480,206],[481,207],[482,209],[482,211],[485,211],[485,214],[485,214],[483,215],[483,216],[482,216],[480,216],[478,216],[478,217],[476,216],[472,216],[472,218]],
      ],
      countryCenter: { x: 475, y: 212.5 },
      countryCode: 'BFA',
      countryId: 25,
      countryName: 'Burkino Faso',
      labelCenter: { x: 476, y: 212.5 },
    },
    26: {
      countryBorder: [
        [[558,263],[557,259],[557,258],[558,258],[559,257],[561,257],[561,258],[561,259],[561,260],[561,260],[560,262],[559,263]],
      ],
      countryCenter: { x: 559, y: 260 },
      countryCode: 'BDI',
      countryId: 26,
      countryName: 'Burundi',
    },
    27: {
      countryBorder: [
        [[751,213],[750,209],[751,207],[755,206],[757,207],[760,208],[761,206],[763,207],[764,209],[764,212],[760,215],[761,216],[758,217],[756,218],[754,217],[753,216]],
      ],
      countryCenter: { x: 757, y: 212 },
      countryCode: 'KHM',
      countryId: 27,
      countryName: 'Cambodia',
    },
    28: {
      countryBorder: [
        [[514,243],[514,243],[512,243],[511,243],[510,243],[505,243],[506,240],[505,238],[503,238],[503,236],[502,236],[502,235],[503,233],[504,230],[505,230],[506,228],[507,228],[509,230],[511,228],[511,227],[512,226],[512,225],[513,223],[514,221],[514,220],[515,219],[516,217],[518,215],[518,214],[518,213],[517,212],[517,211],[518,211],[519,213],[519,215],[519,217],[521,219],[519,219],[518,220],[517,219],[517,221],[518,223],[519,223],[520,224],[521,226],[520,227],[519,230],[518,231],[518,233],[518,234],[518,235],[519,237],[520,238],[521,239],[522,240],[522,242],[522,243],[522,244],[520,244],[518,243]],
      ],
      countryCenter: { x: 510, y: 235 },
      countryCode: 'CMR',
      countryId: 28,
      countryName: 'Cameroon',
    },
    29: {
      countryBorder: [
        [[329,109],[331,110],[333,110],[331,111],[330,111],[328,110],[327,109],[329,108]],
        [[336,102],[335,102],[332,101],[330,100],[331,99],[334,100],[336,101]],
        [[191,104],[190,104],[187,103],[187,102],[185,101],[185,100],[183,99],[184,98],[184,97],[186,98],[187,98],[189,98],[189,99],[190,101],[191,102]],
        [[350,97],[348,100],[350,99],[351,100],[350,101],[352,101],[353,101],[355,102],[354,104],[356,103],[356,105],[356,107],[354,109],[353,109],[352,109],[353,106],[352,106],[349,108],[347,108],[349,107],[347,106],[345,106],[340,106],[340,106],[342,104],[341,104],[344,102],[348,97],[350,96],[352,95],[353,95],[352,96]],
        [[182,88],[182,88],[182,88],[182,88],[184,87],[181,91],[181,93],[180,93],[180,92],[180,90],[180,89],[180,88],[181,87]],
        [[314,65],[313,66],[312,66],[312,65],[312,65],[313,64],[314,64]],
        [[310,63],[306,65],[305,65],[305,64],[307,63],[310,63]],
        [[308,56],[308,57],[309,56],[310,57],[312,58],[313,59],[313,60],[314,60],[315,61],[313,62],[310,61],[310,60],[307,61],[303,63],[303,61],[300,61],[303,60],[305,58],[307,55]],
        [[330,52],[327,52],[328,51],[329,49],[331,49],[332,49],[332,51],[331,51]],
        [[295,47],[293,48],[291,47],[289,47],[287,46],[290,45],[292,44],[293,45],[294,45],[294,46]],
        [[319,114],[318,112],[320,108],[319,107],[317,108],[317,107],[314,109],[313,111],[311,113],[310,113],[309,113],[309,114],[304,114],[301,114],[300,115],[296,117],[296,117],[295,118],[292,118],[290,118],[289,119],[289,119],[289,120],[289,120],[285,122],[282,122],[279,124],[278,124],[278,123],[278,123],[278,123],[279,122],[280,120],[282,118],[282,116],[283,113],[281,112],[281,111],[281,111],[281,111],[280,110],[281,110],[280,110],[279,110],[280,110],[279,109],[279,108],[278,108],[276,107],[275,105],[273,104],[270,105],[270,105],[267,104],[265,105],[263,104],[261,103],[259,103],[259,103],[259,101],[259,101],[258,102],[253,102],[245,102],[237,102],[230,102],[223,102],[217,102],[209,102],[207,102],[200,102],[194,102],[193,102],[191,99],[190,98],[187,97],[187,94],[189,93],[187,91],[189,89],[188,87],[189,85],[191,84],[193,82],[190,81],[191,77],[192,75],[191,74],[190,73],[191,71],[188,72],[184,74],[184,72],[184,71],[182,70],[180,70],[197,55],[209,45],[212,46],[213,47],[215,47],[218,46],[221,45],[224,46],[228,45],[232,44],[232,45],[234,44],[236,43],[237,43],[237,46],[242,44],[240,46],[243,46],[244,45],[246,45],[248,46],[252,47],[254,47],[256,47],[257,48],[253,50],[256,50],[262,50],[264,50],[265,51],[268,50],[267,49],[269,48],[272,48],[274,47],[275,48],[275,49],[278,49],[280,50],[283,50],[286,50],[287,48],[289,48],[292,49],[290,51],[293,49],[294,49],[297,47],[296,45],[295,44],[298,41],[302,40],[304,40],[305,41],[305,44],[302,45],[305,46],[303,48],[307,46],[308,48],[306,50],[307,52],[310,50],[313,47],[316,45],[318,45],[321,45],[322,47],[322,48],[319,49],[320,51],[319,52],[313,54],[310,54],[309,53],[307,55],[304,57],[302,58],[299,60],[296,60],[293,61],[292,63],[289,63],[285,65],[281,68],[278,71],[276,74],[279,74],[278,77],[278,79],[281,78],[285,80],[286,81],[287,82],[289,83],[291,84],[295,84],[297,85],[295,87],[294,90],[294,93],[296,96],[299,95],[301,92],[302,87],[301,86],[306,85],[309,83],[311,81],[312,79],[312,76],[311,74],[315,71],[315,69],[317,65],[319,64],[322,65],[324,65],[326,64],[328,65],[329,67],[329,68],[333,68],[332,70],[331,74],[332,74],[333,76],[337,74],[341,71],[343,70],[343,72],[344,76],[345,79],[344,81],[346,83],[347,84],[351,85],[352,86],[352,88],[353,89],[354,90],[353,93],[351,94],[349,95],[345,96],[341,99],[337,99],[332,99],[329,98],[326,99],[324,101],[320,102],[315,106],[312,109],[314,108],[319,104],[325,102],[328,102],[330,103],[327,105],[327,108],[327,110],[329,112],[333,111],[337,108],[336,110],[338,111],[334,113],[328,115],[325,116],[322,118],[320,118],[321,116],[326,113],[322,113]],
        [[269,37],[267,38],[272,37],[273,38],[277,37],[278,38],[277,40],[279,39],[280,37],[282,36],[283,37],[284,38],[283,40],[282,42],[284,43],[286,44],[285,45],[282,46],[282,47],[281,48],[277,47],[275,46],[272,47],[268,48],[263,48],[259,48],[259,47],[257,46],[255,47],[255,45],[256,44],[260,44],[262,44],[265,43],[262,43],[258,43],[255,43],[255,42],[261,41],[258,41],[255,41],[259,39],[261,38],[268,36]],
        [[288,36],[285,38],[284,36],[285,36],[287,35]],
        [[339,37],[339,37],[337,37],[335,37],[333,38],[332,37],[331,36],[332,35],[333,35],[337,35]],
        [[320,37],[320,38],[324,36],[329,35],[330,38],[329,39],[333,39],[336,38],[339,39],[341,40],[340,41],[344,41],[345,42],[349,43],[350,44],[350,46],[346,48],[349,49],[352,50],[354,52],[357,52],[355,54],[350,57],[348,56],[347,54],[344,54],[343,56],[344,57],[346,58],[346,59],[346,62],[345,64],[343,63],[339,61],[340,63],[342,65],[341,66],[336,65],[333,63],[331,62],[332,61],[330,59],[328,58],[327,59],[321,59],[320,58],[322,57],[326,56],[331,56],[330,55],[332,54],[336,51],[336,50],[336,49],[334,48],[331,47],[332,47],[331,45],[330,45],[329,44],[327,45],[323,45],[317,44],[313,44],[311,43],[310,43],[313,41],[310,41],[312,39],[315,37],[318,36],[323,35]],
        [[297,35],[298,35],[302,35],[302,36],[299,37],[301,38],[298,40],[294,41],[293,41],[292,40],[289,38],[290,37],[294,38],[293,36]],
        [[307,38],[304,39],[302,39],[302,37],[304,36],[306,35],[308,34],[312,34],[315,35],[310,37]],
        [[253,41],[246,42],[247,41],[244,40],[246,39],[250,37],[253,35],[253,34],[260,34],[262,34],[266,34],[267,35],[268,36],[265,36],[258,38],[254,40]],
        [[312,32],[310,33],[307,33],[306,32],[308,31],[311,31],[312,32]],
        [[307,28],[308,29],[306,31],[304,32],[300,32],[299,32],[300,31],[297,31],[299,29],[301,29],[305,28],[307,29]],
        [[289,29],[289,30],[291,30],[292,30],[291,31],[289,32],[282,33],[277,34],[274,34],[275,33],[280,32],[271,32],[269,32],[275,29],[277,29],[281,30],[282,31],[285,31],[286,29],[288,28],[290,28]],
        [[315,27],[316,28],[320,28],[320,29],[319,30],[320,30],[321,31],[323,31],[326,31],[329,31],[333,30],[336,31],[337,31],[336,32],[335,33],[331,34],[329,33],[324,34],[320,34],[317,33],[313,33],[314,31],[315,30],[314,29],[311,29],[310,28],[312,27]],
        [[279,26],[277,28],[274,29],[272,29],[268,30],[265,30],[263,30],[263,30],[268,28],[274,26],[277,27]],
        [[318,26],[317,27],[314,26],[314,26],[317,26],[318,26]],
        [[290,26],[286,27],[284,26],[287,25],[289,25],[291,25]],
        [[294,24],[291,25],[288,25],[289,24],[291,24],[292,24]],
        [[316,25],[313,26],[312,25],[312,24],[313,24],[315,24],[316,24],[317,24]],
        [[309,25],[309,26],[306,25],[304,25],[301,25],[303,24],[302,23],[303,23],[306,23],[309,24]],
        [[335,22],[336,23],[333,23],[328,25],[325,25],[321,25],[321,24],[322,23],[324,22],[321,22],[320,22],[320,21],[322,20],[324,19],[326,19],[326,19],[330,19],[330,20],[333,20],[335,20]],
        [[372,15],[376,15],[379,16],[381,16],[381,17],[376,17],[372,18],[370,18],[374,18],[369,19],[366,20],[361,22],[358,22],[356,22],[351,23],[353,23],[351,23],[352,24],[349,25],[346,26],[344,27],[341,27],[341,28],[344,28],[344,28],[338,30],[334,29],[328,29],[326,29],[323,29],[323,28],[327,27],[328,26],[329,25],[333,26],[332,25],[330,25],[332,24],[336,23],[337,22],[336,22],[336,21],[341,21],[342,21],[345,20],[342,20],[336,20],[334,19],[333,19],[332,18],[333,17],[335,17],[337,17],[341,17],[344,16],[346,16],[347,17],[349,16],[352,15],[355,15],[360,15],[360,15],[365,15],[369,15]]
      ],
      countryCenter: { x: 267, y: 82 },
      countryCode: 'CAN',
      countryId: 29,
      countryName: 'Canada',
    },
    30: {
      countryBorder: [
        [
          [415, 204],
          { c: { x: 415, y: 204.5 } }
        ],
        [
          [418, 203],
          { c: { x: 418.5, y: 203.5 } }
        ],
        [
          [417, 204],
          { c: { x: 417.5, y: 204 } }
        ],
        [
          [419, 201],
          { c: { x: 419.5, y: 201 } }
        ],
        [
          [415, 199],
          { c: { x: 415.5, y: 199.5 } }
        ],
        [
          [419, 199],
          { c: { x: 419, y: 199 } }
        ],
        [
          [413, 199],
          { c: { x: 413.5, y: 199 } }
        ],
        [
          [413, 198],
          { c: { x: 413.5, y: 198.5 } }
        ]
      ],
      countryName: 'Cabo Verde',
      countryCode: 'CPV',
      countryId: 30,
      labelCenter: { x: 416, y: 201 },
    },
    31: {
      countryBorder: [
        [[520,227],[522,227],[523,226],[523,226],[524,227],[527,226],[528,225],[530,224],[529,222],[530,222],[533,222],[535,221],[537,218],[538,216],[540,216],[540,217],[542,219],[542,220],[542,222],[542,223],[543,223],[543,224],[545,225],[546,226],[546,227],[548,229],[549,230],[550,232],[552,233],[552,234],[551,234],[550,234],[548,234],[547,234],[546,235],[546,235],[544,234],[542,236],[540,235],[540,236],[539,237],[537,237],[535,237],[534,235],[531,234],[530,235],[529,237],[529,239],[527,239],[525,238],[524,240],[522,243],[522,242],[522,240],[521,239],[520,238],[519,237],[518,235],[518,234],[518,233],[518,231],[519,230]]
      ],
      countryCenter: { x: 535, y: 229.5 },
      countryCode: 'CAF',
      countryId: 31,
      countryName: 'C. African Rep.',
    },
    32: {
      countryBorder: [
        [[518,211],[518,209],[516,209],[516,207],[515,206],[516,202],[520,199],[520,195],[521,189],[521,188],[520,187],[520,186],[519,185],[518,181],[521,179],[531,185],[542,191],[542,202],[540,202],[539,204],[538,206],[539,207],[538,208],[538,209],[538,210],[538,212],[538,211],[539,213],[539,214],[540,215],[540,216],[538,216],[537,218],[535,221],[533,222],[530,222],[529,222],[530,224],[528,225],[527,226],[524,227],[523,226],[523,226],[522,227],[520,227],[521,226],[520,224],[519,223],[518,223],[517,221],[517,219],[518,220],[519,219],[521,219],[519,217],[519,215],[519,213]]
      ],
      countryCenter: { x: 528.5, y: 203 },
      countryCode: 'TCD',
      countryId: 32,
      countryName: 'Chad',
    },
    33: {
      countryBorder: [
        [[324,407],[327,414],[329,414],[330,414],[330,415],[329,416],[328,416],[326,416],[324,415],[322,414],[318,413],[315,411],[311,408],[313,409],[317,410],[320,412],[321,410],[321,408],[322,407]],
        [[305,318],[305,319],[305,322],[302,323],[303,329],[302,329],[303,331],[302,333],[301,335],[300,338],[301,341],[300,344],[302,349],[303,350],[304,353],[303,356],[304,358],[302,360],[303,363],[304,366],[303,367],[303,370],[304,373],[305,376],[305,377],[306,380],[308,381],[307,383],[309,383],[309,384],[308,385],[309,387],[310,391],[310,393],[310,395],[310,396],[309,398],[310,401],[312,402],[313,402],[314,404],[316,406],[321,406],[324,406],[322,406],[321,407],[319,408],[320,411],[319,411],[316,410],[313,408],[313,408],[309,406],[308,404],[307,403],[306,401],[303,396],[303,393],[305,391],[301,390],[302,387],[301,382],[304,383],[303,377],[301,376],[302,380],[300,380],[300,375],[299,370],[299,368],[298,365],[296,362],[297,361],[298,357],[298,352],[298,347],[297,343],[297,340],[296,337],[297,333],[297,327],[297,321],[297,314],[296,309],[295,305],[296,304],[297,303],[298,305],[299,307],[300,308],[300,311],[302,314],[303,319]],
        [
          [199.5,332.5],[199.5,333.5],[200.5,333.5],[200.5,332.5],[199.5,332.5],
          { c: { x: 200, y: 333, label: { x: 200, y: 333, countryName: 'Easter Is' } } },
        ],
      ],
      countryCenter: { x: 300.5, y: 357 },
      countryCode: 'CHL',
      countryId: 33,
      countryName: 'Chile',
    },
    34: {
      countryBorder: [
        [[769,193],[767,195],[765,194],[764,191],[765,190],[768,189],[769,189],[770,190],[769,191]],
        [[780,101],[784,103],[787,106],[790,106],[792,105],[795,104],[796,106],[795,108],[797,111],[797,114],[794,113],[792,114],[795,117],[796,120],[795,120],[796,122],[794,120],[794,122],[791,123],[792,125],[790,124],[788,124],[788,126],[786,127],[785,129],[782,130],[781,131],[778,132],[779,131],[778,130],[779,128],[777,126],[775,127],[773,129],[773,131],[770,131],[770,133],[772,135],[774,135],[775,137],[777,138],[779,135],[782,137],[784,137],[785,138],[782,139],[781,141],[779,142],[779,144],[782,146],[784,149],[787,152],[790,154],[790,156],[789,157],[790,159],[792,160],[792,162],[792,164],[791,165],[790,168],[789,172],[787,176],[784,178],[781,181],[778,181],[777,183],[776,182],[775,183],[771,185],[769,185],[768,188],[767,188],[766,186],[766,185],[763,184],[761,185],[759,184],[757,183],[757,181],[755,180],[753,179],[752,181],[749,181],[747,181],[746,182],[744,182],[745,186],[744,186],[744,185],[743,184],[742,185],[740,184],[738,183],[739,180],[737,180],[736,177],[733,177],[733,174],[735,171],[734,169],[734,167],[732,166],[731,164],[730,164],[727,164],[727,163],[726,161],[724,162],[722,161],[719,163],[718,165],[716,166],[714,165],[713,165],[711,164],[710,165],[708,167],[708,165],[706,165],[703,165],[700,164],[698,163],[696,163],[695,161],[693,161],[690,159],[688,158],[687,159],[683,156],[680,155],[678,151],[680,152],[680,150],[679,149],[678,146],[675,143],[670,141],[669,139],[667,138],[666,137],[665,135],[665,134],[663,133],[662,133],[661,131],[661,130],[661,129],[663,128],[664,127],[667,128],[667,126],[670,125],[671,124],[674,123],[674,122],[673,120],[675,119],[671,114],[675,113],[676,112],[675,107],[680,108],[681,107],[680,104],[682,104],[683,102],[683,101],[685,103],[688,105],[692,106],[694,108],[695,112],[696,113],[699,114],[703,114],[706,116],[708,116],[710,119],[713,121],[715,121],[721,121],[724,121],[726,121],[731,123],[734,123],[735,124],[737,123],[741,122],[744,121],[746,120],[747,119],[749,118],[748,117],[746,116],[746,114],[748,114],[751,115],[752,113],[755,112],[756,110],[757,109],[760,109],[762,109],[762,108],[759,106],[756,105],[755,106],[752,106],[751,106],[750,105],[750,102],[750,100],[753,101],[755,99],[754,98],[754,95],[755,94],[754,92],[752,91],[753,90],[755,89],[758,89],[762,90],[765,91],[768,94],[770,95],[772,97],[775,100]],
      ],
      countryCenter: { x: 729, y: 138.5 },
      countryCode: 'CHN',
      countryId: 34,
      countryName: 'China',
    },
    35: {
      countryBorder: [
        [[279,250],[278,249],[276,248],[276,249],[273,248],[273,247],[272,247],[270,245],[269,244],[270,244],[270,243],[271,242],[272,241],[273,240],[274,238],[273,237],[274,235],[273,233],[274,232],[274,229],[273,228],[273,226],[274,227],[274,226],[274,224],[274,223],[276,223],[278,221],[279,221],[279,220],[280,218],[281,216],[283,216],[283,215],[285,216],[287,214],[288,213],[290,212],[291,212],[291,213],[291,214],[289,215],[288,216],[287,217],[286,218],[286,220],[285,222],[286,222],[287,224],[287,224],[287,225],[287,227],[287,227],[288,227],[288,228],[292,228],[293,229],[295,231],[296,231],[298,231],[300,231],[301,231],[300,233],[299,234],[299,236],[300,238],[300,239],[300,240],[299,241],[300,242],[301,243],[301,246],[301,246],[300,244],[300,243],[299,244],[294,244],[294,246],[295,247],[295,248],[295,247],[293,248],[293,250],[294,251],[295,253],[295,254],[294,263],[292,261],[291,261],[293,258],[291,256],[289,257],[288,256],[287,257],[285,257],[283,253],[282,253],[281,251],[279,250]],
      ],
      countryCenter: { x: 285, y: 237.5 },
      countryCode: 'COL',
      countryId: 35,
      countryName: 'Columbia',
    },
    36: {
      countryBorder: [
        [
          [595,287],
          { c: { x: 595, y: 287 } }
        ],
        [
          [596.5,286.5],
          { c: { x: 596.5, y: 286.5 } }
        ],
        [
          [594.5,285],
          { c: { x: 594.5, y: 285 } }
        ]
      ],
      countryCode: 'COM',
      countryId: 36,
      countryName: 'Comoros',
      labelCenter: { x: 595, y: 286 }
    },
    37: {
      countryBorder: [
        [[514,264],[513,263],[512,263],[511,265],[509,262],[511,260],[510,258],[511,257],[513,257],[513,255],[514,257],[517,257],[518,256],[518,254],[518,251],[516,249],[518,246],[517,245],[515,246],[514,244],[514,243],[518,243],[520,244],[522,244],[522,243],[524,240],[525,238],[527,239],[529,239],[529,241],[528,242],[527,244],[527,247],[527,249],[527,250],[527,251],[526,252],[524,253],[523,255],[522,258],[522,260],[521,261],[520,263],[518,265],[517,264],[517,263],[516,263],[515,264]]
      ],
      countryCenter: { x: 522, y: 249 },
      countryCode: 'COG',
      countryId: 37,
      countryName: 'Congo',
    },
    38: {
      countryBorder: [
        [[259,225],[258,224],[257,223],[258,223],[258,222],[257,222],[256,221],[255,221],[255,220],[254,219],[254,220],[254,221],[253,220],[252,220],[252,219],[252,218],[253,217],[252,217],[252,216],[253,216],[255,217],[255,216],[256,216],[256,217],[257,217],[258,217],[258,218],[259,219],[261,221],[260,221],[259,222],[260,223],[260,223],[260,224],[259,224]]
      ],
      countryCenter: { x: 256.5, y: 220.5 },
      countryCode: 'CRI',
      countryId: 38,
      countryName: 'Costa Rica',
    },
    39: {
      countryBorder: [
        [[472,234],[471,235],[469,234],[467,234],[464,234],[462,235],[460,236],[459,236],[459,234],[459,234],[459,232],[458,231],[457,231],[457,230],[457,229],[457,227],[457,226],[458,226],[458,225],[458,224],[458,224],[459,224],[458,221],[458,220],[458,219],[458,219],[459,218],[459,219],[461,219],[462,218],[462,218],[463,218],[464,219],[464,219],[465,218],[466,219],[467,220],[468,221],[469,220],[470,220],[472,220],[473,225],[472,227],[471,231],[472,233]]
      ],
      countryCenter: { x: 465, y: 227 },
      countryCode: 'CIV',
      countryId: 39,
      countryName: 'Côte d\'Ivoire',
    },
    40: {
      countryBorder: [
        [[524,111],[525,113],[526,113],[525,114],[524,114],[522,114],[520,113],[519,113],[519,114],[518,113],[517,115],[518,116],[519,117],[520,118],[521,119],[522,120],[524,121],[524,122],[522,120],[520,119],[518,118],[516,116],[516,116],[515,115],[515,114],[514,113],[513,115],[512,114],[512,113],[512,113],[514,113],[514,112],[515,113],[516,113],[516,112],[517,112],[517,110],[519,110],[520,110],[521,111],[523,112]]
      ],
      countryCenter: { x: 519, y: 114 },
      countryId: 40,
      countryCode: 'HRV',
      countryName: 'Croatia',
    },
    41: {
      countryBorder: [
        [[266,180],[268,180],[270,180],[272,181],[273,182],[275,182],[276,182],[278,184],[280,186],[281,186],[282,186],[282,187],[284,187],[286,188],[285,189],[283,189],[282,190],[280,189],[276,190],[278,188],[277,187],[275,187],[275,186],[274,184],[273,185],[270,184],[270,183],[266,183],[265,182],[267,181],[264,181],[262,183],[261,183],[260,183],[259,184],[258,184],[259,183],[260,181],[261,181],[263,180],[265,180]]
      ],
      countryCenter: { x: 274, y: 184 },
      countryCode: 'CUB',
      countryId: 41,
      countryName: 'Cuba',
    },
    42: {
      countryBorder: [
        [[562,144],[562,144],[562,143],[564,143],[566,142],[565,143],[565,144],[565,144],[563,145],[561,145],[561,144]]
      ],
      countryCenter: { x: 563.5, y: 143.5 },
      countryCode: 'CYP',
      countryId: 42,
      countryName: 'Cypress',
    },
    43: {
      countryBorder: [
        [[523,101],[524,101],[526,102],[527,101],[528,101],[530,101],[532,102],[531,103],[531,104],[528,103],[527,104],[526,105],[526,104],[524,105],[523,106],[521,106],[519,105],[519,104],[519,103],[518,103],[517,103],[515,102],[514,102],[513,104],[511,103],[510,101],[509,101],[508,99],[509,98],[510,97],[512,97],[512,96],[513,96],[514,96],[515,97],[517,97],[517,98],[518,99],[518,98],[520,98],[520,99],[522,99],[523,101]]
      ],
      countryCenter: { x: 515.5, y: 99.5 },
      countryCode: 'CZE',
      countryId: 43,
      countryName: 'Czechoslovakia',
      labelCenter: { x: 520, y: 101 },
    },
    44: {
      countryBorder: [
        [[563,243],[562,244],[561,245],[560,246],[559,248],[559,250],[558,251],[558,254],[558,254],[557,256],[557,256],[557,258],[557,259],[558,263],[558,266],[558,267],[558,269],[560,271],[561,275],[560,274],[557,275],[556,275],[555,277],[556,279],[555,282],[555,285],[555,286],[557,287],[558,286],[558,290],[556,290],[555,288],[554,287],[552,286],[551,285],[550,286],[548,285],[547,284],[545,283],[544,284],[544,283],[543,283],[542,282],[540,283],[539,283],[538,283],[538,279],[538,278],[537,276],[538,275],[537,273],[537,272],[534,272],[534,270],[533,270],[533,271],[531,271],[530,273],[530,274],[529,273],[528,274],[526,274],[525,272],[524,271],[524,270],[523,267],[515,267],[514,268],[513,268],[512,268],[512,267],[513,267],[513,265],[513,265],[514,264],[515,264],[516,263],[517,263],[517,264],[518,265],[520,263],[521,261],[522,260],[522,258],[523,255],[524,253],[526,252],[527,251],[527,250],[527,249],[527,247],[527,244],[528,242],[529,241],[529,239],[529,237],[530,235],[531,234],[534,235],[535,237],[537,237],[539,237],[540,236],[540,235],[542,236],[544,234],[546,235],[546,235],[547,234],[548,234],[550,234],[551,234],[552,234],[554,236],[555,237],[556,236],[557,236],[559,236],[559,237],[562,239],[562,242]]
      ],
      countryCenter: { x: 537.5, y: 262 },
      countryCode: 'COD',
      countryId: 44,
      countryName: 'DR. Congo',
    },
    45: {
      countryBorder: [
        [[508,83],[506,85],[504,84],[504,83],[507,82]],
        [[502,85],[500,85],[499,85],[498,83],[497,81],[498,80],[498,79],[500,79],[501,78],[503,77],[503,79],[502,80],[502,80],[504,81],[503,82],[502,82],[501,84]],
      ],
      countryCenter: { x: 500.5, y: 81 },
      countryCode: 'DNK',
      countryId: 45,
      countryName: 'Denmark',
    },
    46: {
      countryCenter: { x: 317.5, y: 203 },
      countryCode: 'DMA',
      countryId: 46,
      countryName: 'Dominica',
    },
    47: {
      countryBorder: [
        [[292,190], [296,190],[297,191],[298,191],[298,192],[299,192],[300,193],[299,195],[298,194],[297,194],[296,194],[295,195],[294,195],[294,194],[293,194],[292,196],[291,196],[291,193],[292,193],[292,192]]
      ],
      countryCenter: { x: 295.5, y: 193 },
      countryCode: 'DOM',
      countryId: 47,
      countryName: 'Dominican Rep.',
      labelCenter: { x: 290, y: 191 },
    },
    48: {
      countryBorder: [
        [[811,276],[812,276],[814,275],[816,275],[817,275],[818,275],[817,276],[814,277],[811,278],[811,277]]
      ],
      countryCenter: { x: 825, y: 276.5 },
      countryCode: 'TLS',
      countryId: 48,
      countryName: 'Timor-Leste',
    },
    49: {
      countryBorder: [
        [[266,260],[267,258],[267,256],[266,258],[264,256],[264,255],[264,253],[265,252],[265,250],[266,248],[266,247],[268,247],[270,245],[272,247],[273,247],[273,248],[276,249],[276,248],[278,249],[279,250],[279,252],[278,254],[275,257],[272,259],[271,261],[270,263],[269,265],[268,263],[267,263],[265,263],[265,262],[266,261]]
      ],
      countryCenter: { x: 271.5, y: 253 },
      countryCode: 'ECU',
      countryId: 49,
      countryName: 'Equador',
    },
    50: {
      countryBorder: [
        [[576,183],[565,183],[555,183],[545,183],[544,172],[544,161],[543,159],[543,157],[543,156],[544,154],[547,154],[549,155],[552,156],[553,156],[555,155],[556,155],[558,154],[560,155],[561,156],[562,155],[564,156],[566,156],[567,155],[569,161],[568,162],[568,164],[567,166],[567,166],[566,165],[565,164],[563,160],[562,160],[564,163],[565,166],[568,171],[569,172],[570,174],[572,177],[572,178],[572,180],[575,183]]
      ],
      countryCenter: { x: 559.5, y: 168.5 },
      countryCode: 'EGY',
      countryId: 50,
      countryName: 'Egypt',
    },
    51: {
      countryBorder: [
        [[248,209],[247,210],[246,210],[245,210],[244,209],[242,209],[242,208],[242,208],[243,207],[243,207],[243,206],[244,206],[244,206],[245,207],[246,207],[246,208],[247,207],[248,208],[248,208]]
      ],
      countryCenter: { x: 245, y: 208 },
      countryCode: 'SLV',
      countryId: 51,
      countryName: 'El Salvador',
      labelCenter: { x: 242, y: 209 },
    },
    52: {
      countryBorder: [
        [[505,247],[504,246],[505,243],[510,243],[510,246],[506,246]]
      ],
      countryCenter: { x: 507, y: 245 },
      countryCode: 'GNQ',
      countryId: 52,
      countryName: 'Eq\'ial Guinea',
      labelCenter: { x: 500, y: 245 },
    },
    53: {
      countryBorder: [
        [[592,212],[591,211],[589,209],[588,208],[588,207],[585,206],[583,206],[583,205],[581,206],[580,204],[579,207],[576,206],[575,205],[576,200],[576,198],[577,197],[579,197],[580,195],[582,199],[583,202],[584,203],[588,206],[590,208],[591,209],[592,210],[593,211],[593,212]]
      ],
      countryCenter: { x: 584, y: 203.5 },
      countryCode: 'ERI',
      countryId: 53,
      countryName: 'Eritrea',
    },
    54: {
      countryBorder: [
        [[532,77],[532,75],[532,76],[530,75],[530,73],[532,72],[535,72],[537,72],[539,72],[540,73],[539,74],[540,77],[539,78],[537,78],[535,77],[534,77]]
      ],
      countryCenter: { x: 535, y: 75 },
      countryCode: 'EST',
      countryId: 54,
      countryName: 'Estonia',
    },
    55: {
      countryBorder: [
        [[562,330],[562,332],[560,332],[559,330],[559,329],[560,328],[560,327],[561,327],[562,327],[562,329]]
      ],
      countryCenter: { x: 560.5, y: 329.5 },
      countryCode: 'SWZ',
      countryId: 55,
      countryName: 'Eswatini',
    },
    56: {
      countryBorder: [
        [[583,206],[585,206],[588,207],[588,208],[589,209],[591,211],[592,212],[591,213],[590,214],[590,215],[590,216],[592,216],[592,216],[593,217],[592,218],[593,219],[594,221],[595,222],[604,225],[606,225],[599,234],[596,235],[593,237],[592,237],[591,238],[589,238],[588,237],[586,238],[585,239],[583,239],[582,239],[582,239],[581,239],[578,236],[576,236],[575,235],[575,233],[573,233],[572,230],[571,229],[570,228],[569,226],[567,226],[568,224],[569,224],[570,223],[570,221],[570,217],[572,217],[572,215],[573,213],[574,212],[575,209],[576,206],[579,207],[580,204],[581,206],[583,205]]
      ],
      countryCenter: { x: 586.5, y: 221.5 },
      countryCode: 'ETH',
      countryId: 56,
      countryName: 'Ethiopia',
    },
    57: {
      countryBorder: [
        [[948,302],[949,303],[948,304],[947,305],[945,304],[945,303],[946,302],[948,302]],
        [[951,300],[950,301],[949,300],[951,299],[952,299],[954,298],[953,299]],
      ],
      countryCenter: { x: 949, y: 301.5 },
      countryCode: 'FIJ',
      countryId: 57,
      countryName: 'Fiji',
    },
    58: {
      countryBorder: [
        [[535,47],[535,49],[538,50],[537,52],[540,55],[539,57],[542,59],[541,61],[545,63],[544,64],[543,66],[539,70],[535,70],[532,71],[528,71],[527,70],[525,69],[525,66],[523,64],[524,62],[526,61],[530,58],[531,57],[530,56],[527,55],[527,54],[526,50],[522,48],[519,47],[521,46],[523,47],[525,47],[528,48],[529,47],[530,45],[533,44],[535,45]],
      ],
      countryCenter: { x: 533, y: 65 },
      countryCode: 'FIN',
      countryId: 58,
      countryName: 'Finland',
    },
    59: {
      countryBorder: [
        [
          [503,123],[502,125],[501,124],[500,122],[501,121],[502,120],
          { c: { x: 501.5, y: 122.5, label: { x: 501.5, y: 122.5, countryName: 'Corsica' } } }
        ],
        [
          [493,101],[493,101],[494,101],[495,102],[498,102],[497,104],[497,106],[496,107],[495,107],[495,107],[494,109],[494,110],[495,110],[496,111],[496,112],[496,113],[496,114],[496,116],[498,117],[497,118],[495,120],[491,119],[487,120],[487,122],[484,122],[481,121],[480,121],[476,120],[475,119],[476,117],[477,111],[474,108],[473,106],[469,105],[469,103],[472,103],[476,103],[475,100],[477,101],[483,99],[483,97],[485,96],[486,97],[487,97],[488,98],[489,100],[491,99],
          { c: { x: 483.5, y: 109, label: { x: 483.5, y: 114, countryName: 'France' } } }
        ],
        [
          [334,243],[335,241],[335,240],[336,239],[335,237],[335,235],[336,232],[337,233],[339,233],[342,236],[342,237],[340,240],[340,242],[339,243],[337,243],[337,243],[336,242],[336,243],
          { c: { x: 338, y: 237.5, label: { x: 345, y: 236, countryName: 'French Guiana' } } }
        ],
      ],
      countryCode: 'FRA',
      countryId: 59,
    },
    60: {
      countryCenter: { x: 314, y: 194 },
      countryCode: 'MAC',
      countryId: 60,
      countryName: 'St. Marten',
      labelCenter: { x: 321, y: 194 },
    },
    61: {
      countryBorder: [
        [[509,262],[506,259],[505,256],[503,253],[503,252],[504,251],[504,249],[505,247],[506,246],[510,246],[510,243],[511,243],[512,243],[514,243],[514,243],[514,244],[515,246],[517,245],[518,246],[516,249],[518,251],[518,254],[518,256],[517,257],[514,257],[513,255],[513,257],[511,257],[510,258],[511,260]],
      ],
      countryCenter: { x: 510.5, y: 252.5 },
      countryCode: 'GAB',
      countryId: 61,
      countryName: 'Gabon',
    },
    62: {
      countryBorder: [
        [[435,210],[435,209],[438,208],[439,208],[440,208],[441,208],[442,208],[442,208],[443,209],[442,209],[441,209],[440,209],[439,210],[438,210],[437,210]],
      ],
      countryCenter: { x: 439, y: 209 },
      countryCode: 'GMB',
      countryId: 62,
      countryName: 'Gambia',
    },
    63: {
      countryBorder: [
        [[581,124],[581,123],[580,121],[578,120],[577,120],[576,119],[576,118],[578,119],[582,119],[585,121],[586,121],[587,121],[590,121],[591,123],[592,123],[592,124],[593,125],[593,126],[592,126],[590,125],[589,125],[586,126],[583,124]],
      ],
      countryCenter: { x: 584.5, y: 122 },
      countryCode: 'GEO',
      countryId: 63,
      countryName: 'Georgia',
    },
    64: {
      countryBorder: [
        [[502,85],[502,86],[504,87],[504,88],[506,87],[508,86],[510,88],[511,88],[512,90],[511,91],[512,92],[513,93],[513,94],[514,96],[513,96],[512,96],[512,97],[510,97],[509,98],[508,99],[508,99],[509,101],[510,101],[511,103],[510,104],[510,104],[510,106],[510,107],[509,106],[508,106],[506,107],[504,106],[504,107],[503,106],[502,107],[500,106],[499,106],[497,106],[497,104],[498,102],[495,102],[494,101],[494,100],[494,99],[494,97],[493,94],[495,94],[495,93],[496,90],[495,89],[496,89],[497,89],[498,89],[499,88],[499,87],[499,85],[500,85]],
      ],
      countryCenter: { x: 503, y: 95 },
      countryCode: 'DEU',
      countryId: 64,
      countryName: 'Germany',
    },
    65: {
      countryBorder: [
        [[482,232],[478,233],[477,234],[474,235],[472,234],[472,233],[471,231],[472,227],[473,225],[472,220],[472,218],[472,216],[476,216],[478,217],[478,216],[480,216],[479,217],[481,219],[481,221],[481,223],[481,224],[481,227],[481,229],[482,231]],
      ],
      countryCenter: { x: 476.5, y: 230 },
      countryCode: 'GHA',
      countryId: 65,
      countryName: 'Ghana',
    },
    66: {
      countryBorder: [
        [[539,142],[540,143],[542,143],[544,143],[544,143],[545,143],[545,144],[542,144],[542,144],[539,143]],
        [[543,127],[542,126],[540,126],[538,127],[539,129],[538,129],[537,129],[535,128],[535,128],[536,130],[537,131],[536,132],[538,133],[539,134],[539,136],[537,135],[538,137],[536,137],[537,140],[536,140],[534,138],[532,136],[532,134],[531,133],[529,131],[529,130],[530,129],[530,128],[531,127],[531,126],[533,126],[533,126],[535,126],[535,125],[536,125],[537,125],[539,124],[541,125],[543,125],[543,124],[544,124],[544,126]],
      ],
      countryCenter: { x: 535, y: 132 },
      countryCode: 'GRC',
      countryId: 66,
      countryName: 'Greece',
    },
    67: {
      countryBorder: [
        [[405,16],[411,15],[417,15],[419,15],[425,14],[437,15],[447,16],[443,17],[437,17],[429,17],[429,17],[435,17],[440,18],[443,17],[444,18],[442,19],[446,18],[454,17],[459,18],[460,19],[453,20],[452,20],[446,21],[450,21],[448,22],[446,24],[446,26],[447,28],[445,28],[442,28],[445,30],[445,32],[443,32],[444,34],[440,34],[442,35],[442,36],[439,36],[436,36],[438,38],[438,39],[435,38],[433,39],[436,39],[438,41],[438,43],[435,43],[434,42],[432,41],[432,43],[429,44],[434,44],[437,44],[431,46],[425,48],[420,49],[417,49],[415,50],[412,53],[407,55],[405,55],[402,56],[399,56],[397,58],[396,60],[395,61],[391,64],[391,66],[389,68],[387,71],[384,71],[382,69],[378,69],[376,67],[376,64],[374,61],[373,59],[374,57],[372,54],[374,53],[373,52],[376,49],[380,48],[381,47],[382,45],[379,45],[378,46],[376,46],[374,45],[375,44],[377,42],[378,42],[382,43],[379,41],[378,41],[376,41],[375,40],[378,38],[378,37],[377,35],[376,33],[375,32],[375,31],[371,30],[368,30],[363,30],[359,30],[357,29],[355,28],[360,27],[364,27],[357,26],[354,25],[355,24],[363,23],[370,22],[371,22],[367,21],[369,20],[376,19],[379,19],[379,18],[383,17],[388,17],[393,17],[394,17],[399,16],[403,17],[405,17],[408,18],[405,17]],
      ],
      countryCenter: { x: 407, y: 34 },
      countryCode: 'GRL',
      countryId: 67,
      countryName: 'Greenland',
    },
    68: {
      countryCenter: { x: 316.5, y: 213 },
      countryCode: 'GRD',
      countryId: 68,
      countryName: 'Grenada',
    },
    69: {
      countryBorder: [
        [[242,208],[240,208],[239,208],[237,207],[236,206],[236,205],[237,204],[236,204],[238,201],[241,201],[242,200],[241,200],[241,199],[240,199],[239,198],[240,198],[241,196],[243,196],[245,196],[245,198],[245,202],[245,202],[246,202],[246,202],[247,202],[246,203],[244,204],[244,205],[244,205],[244,206],[243,206],[243,207],[243,207],[242,208]],
      ],
      countryCenter: { x: 241.5, y: 202 },
      countryCode: 'GTM',
      countryId: 69,
      countryName: 'Guatamala',
      labelCenter: { x: 240, y: 203 },
    },
    70: {
      countryBorder: [
        [[457,226],[456,226],[456,228],[455,227],[455,227],[455,226],[454,224],[453,224],[452,224],[452,224],[452,223],[451,222],[451,222],[451,220],[450,219],[448,219],[447,220],[447,220],[446,221],[446,221],[444,223],[443,221],[442,220],[442,219],[441,219],[441,217],[440,217],[439,216],[441,215],[441,215],[442,214],[443,214],[443,214],[443,213],[443,213],[443,212],[445,212],[446,212],[447,212],[447,212],[449,212],[449,212],[449,213],[450,213],[450,213],[451,213],[452,214],[453,214],[453,213],[454,213],[455,212],[455,212],[456,213],[456,214],[457,215],[457,216],[457,217],[457,217],[458,217],[457,218],[458,219],[458,219],[458,220],[458,221],[459,224],[458,224],[458,224],[458,225],[458,226]]
      ],
      countryCenter: { x: 449, y: 220 },
      countryCode: 'GIN',
      countryId: 70,
      countryName: 'Guinea',
    },
    71: {
      countryBorder: [
        [[439,216],[438,215],[437,215],[436,214],[436,213],[436,213],[435,212],[437,212],[438,212],[438,211],[443,212],[443,213],[443,213],[443,214],[443,214],[442,214],[441,215],[441,215]]
      ],
      countryCenter: { x: 439, y: 213.5 },
      countryCode: 'GNB',
      countryId: 71,
      countryName: 'Guinea Bassau',
    },
    72: {
      countryBorder: [
        [[321,224],[323,225],[324,227],[324,229],[325,229],[327,230],[328,232],[327,234],[325,235],[326,236],[325,237],[326,239],[327,239],[327,241],[329,244],[328,244],[327,244],[326,244],[325,245],[324,245],[324,246],[322,246],[321,244],[321,243],[320,241],[320,239],[321,238],[321,236],[320,236],[320,234],[319,234],[318,234],[316,232],[317,231],[317,229],[319,229],[319,228],[318,227],[319,226]]
      ],
      countryCenter: { x: 322.5, y: 232 },
      countryCode: 'GUY',
      countryId: 72,
      countryName: 'Guyana',
    },
    73: {
      countryBorder: [
        [[292,190],[292,192],[292,193],[291,193],[291,194],[291,195],[290,195],[288,195],[287,195],[285,195],[284,194],[285,193],[287,194],[289,194],[290,193],[289,192],[289,191],[287,190],[288,189],[290,190]]
      ],
      countryCenter: { x: 288, y: 192.5 },
      countryCode: 'HTI',
      countryId: 73,
      countryName: 'Haiti',
      labelCenter: { x: 287, y: 194 },
    },
    74: {
      countryBorder: [
        [[249,210],[248,209],[248,209],[248,208],[248,208],[247,207],[246,208],[246,207],[245,207],[244,206],[244,206],[244,205],[244,205],[244,204],[246,203],[247,202],[247,202],[248,202],[249,202],[249,202],[249,202],[251,202],[252,202],[253,202],[253,201],[254,201],[254,202],[255,202],[256,201],[257,202],[257,202],[258,202],[259,203],[260,203],[260,204],[259,204],[259,205],[258,205],[257,205],[257,205],[256,205],[256,205],[256,205],[255,206],[255,206],[255,206],[254,207],[253,207],[253,208],[252,207],[252,208],[251,208],[250,208],[250,210],[250,210],[250,210]]
      ],
      countryCenter: { x: 250, y: 205 },
      countryCode: 'HND',
      countryId: 74,
      countryName: 'Honduras',
    },
    75: {
      countryBorder: [
        [[518,109],[518,107],[518,106],[519,106],[519,105],[521,106],[521,106],[523,106],[524,105],[524,105],[526,104],[526,105],[527,104],[527,104],[528,103],[531,104],[531,104],[533,105],[533,106],[531,106],[531,108],[529,110],[527,111],[526,111],[524,111],[523,112],[521,111],[520,110],[519,110],[518,109]]
      ],
      countryCenter: { x: 527, y: 107.5 },
      countryCode: 'HUN',
      countryId: 75,
      countryName: 'Hungary',
    },
    76: {
      countryBorder: [
        [[451,54],[450,55],[452,57],[449,59],[443,61],[441,61],[439,61],[433,60],[435,59],[431,58],[435,57],[435,56],[431,56],[432,54],[435,54],[438,55],[442,54],[444,55],[447,53]]
      ],
      countryCenter: { x: 441.5, y: 58 },
      countryCode: 'ISL',
      countryId: 76,
      countryName: 'Iceland',
    },
    77: {
      countryBorder: [
        [[675,143],[678,146],[679,149],[680,150],[680,152],[678,151],[680,155],[683,156],[687,159],[686,160],[685,163],[688,164],[691,165],[694,167],[698,167],[700,169],[702,169],[705,170],[707,170],[707,169],[706,167],[706,165],[708,165],[708,167],[709,168],[711,169],[713,169],[715,169],[717,169],[717,167],[716,166],[718,165],[719,163],[722,161],[724,162],[726,161],[727,163],[727,164],[730,164],[730,165],[729,166],[730,168],[728,167],[725,169],[726,171],[725,174],[725,175],[724,178],[722,177],[722,180],[722,181],[722,182],[721,183],[719,178],[718,178],[718,180],[717,179],[717,177],[718,177],[719,174],[717,174],[715,174],[712,173],[712,171],[711,171],[708,170],[708,172],[710,173],[708,175],[708,176],[710,176],[710,178],[711,181],[712,183],[711,184],[710,184],[707,185],[707,187],[706,189],[702,191],[700,194],[698,196],[696,198],[696,200],[695,200],[692,201],[691,202],[691,204],[691,208],[692,210],[691,213],[691,218],[690,218],[689,221],[690,222],[687,223],[686,225],[685,226],[683,223],[681,218],[680,215],[679,214],[678,211],[677,207],[676,205],[673,201],[672,195],[670,192],[670,188],[669,185],[666,187],[664,187],[660,183],[661,182],[660,181],[657,178],[658,176],[664,176],[663,174],[661,172],[661,170],[659,168],[661,165],[664,165],[666,162],[667,159],[669,156],[669,154],[671,152],[668,151],[667,149],[665,146],[666,145],[670,145],[673,145]]
      ],
      countryCenter: { x: 693.5, y: 184.5 },
      countryCode: 'IND',
      countryId: 77,
      countryName: 'India',
      labelCenter: { x: 685, y: 180 },
    },
    78: {
      countryBorder: [
        [[800,280],[798,280],[795,278],[798,278],[799,279],[800,280]],
        [[811,276],[811,277],[811,278],[809,280],[807,281],[807,280],[807,279],[808,278]],
        [[793,274],[794,275],[795,275],[796,276],[793,276],[791,277],[789,277],[790,275],[792,275]],
        [[806,274],[805,276],[801,276],[798,276],[798,275],[800,274],[802,275],[803,275]],
        [[768,270],[773,270],[774,269],[779,270],[780,272],[784,273],[787,275],[784,276],[781,275],[778,275],[776,275],[773,274],[770,273],[768,273],[767,273],[762,272],[762,270],[760,270],[762,267],[765,268],[767,269],[768,269]],
        [[838,268],[836,270],[836,268],[837,267],[837,266],[838,267]],
        [[818,260],[817,261],[815,260],[815,259],[818,259]],
        [[827,259],[828,261],[826,260],[823,260],[822,260],[820,260],[821,258],[824,258]],
        [[855,257],[855,267],[854,277],[852,275],[849,274],[848,275],[845,275],[846,272],[848,272],[848,268],[846,266],[841,263],[839,263],[835,260],[835,262],[833,262],[833,261],[833,260],[831,258],[834,257],[836,257],[836,256],[832,256],[831,254],[828,254],[827,252],[831,252],[832,251],[836,252],[837,253],[837,258],[840,260],[843,257],[846,255],[848,255],[850,256],[852,257]],
        [[813,245],[811,248],[809,249],[806,248],[802,248],[800,249],[799,251],[802,254],[803,252],[808,251],[808,253],[807,252],[806,254],[803,255],[806,259],[805,260],[807,264],[807,266],[806,267],[805,265],[806,263],[803,264],[803,263],[803,262],[801,260],[802,257],[800,258],[800,262],[800,266],[798,267],[797,266],[798,263],[798,260],[797,260],[796,258],[797,256],[797,254],[799,249],[799,248],[802,246],[804,246],[807,247],[810,247],[813,245]],
        [[822,246],[822,249],[821,248],[820,250],[822,252],[821,252],[820,250],[819,246],[819,244],[820,243],[820,245],[822,245]],
        [[772,243],[772,246],[774,247],[776,247],[777,247],[779,245],[780,245],[783,246],[785,245],[786,241],[787,240],[788,237],[791,237],[793,237],[792,240],[794,243],[793,244],[797,247],[793,247],[792,249],[793,252],[790,254],[790,257],[789,262],[788,261],[785,262],[784,260],[782,260],[781,259],[778,260],[777,259],[775,259],[773,258],[773,254],[771,254],[770,251],[770,248],[770,246]],
        [[761,267],[758,267],[756,265],[753,262],[751,260],[750,258],[748,256],[746,252],[744,249],[743,246],[742,244],[740,242],[738,240],[736,238],[733,235],[733,233],[735,233],[739,234],[741,237],[743,239],[745,240],[748,243],[750,243],[753,245],[754,248],[756,249],[755,252],[757,253],[758,253],[758,255],[759,257],[761,257],[762,259],[761,263] ]
      ],
      countryCenter: { x: 800, y: 261 },
      countryCode: 'IDN',
      countryId: 78,
      countryName: 'Indonesia',
    },
    79: {
      countryBorder: [
        [[614,137],[616,137],[617,135],[619,135],[620,135],[622,135],[625,136],[627,137],[630,139],[632,140],[633,142],[633,146],[632,148],[634,148],[633,150],[634,152],[635,154],[637,155],[637,157],[635,160],[637,161],[638,163],[641,164],[641,167],[643,167],[643,169],[639,170],[639,174],[634,173],[631,172],[628,172],[627,168],[625,168],[623,168],[621,170],[618,169],[615,166],[612,166],[610,163],[608,159],[606,159],[605,158],[604,159],[602,158],[602,156],[601,156],[601,154],[600,152],[596,150],[594,147],[594,145],[595,144],[595,142],[593,141],[591,137],[589,135],[590,134],[588,131],[590,130],[590,131],[592,132],[594,133],[594,133],[597,130],[598,130],[599,131],[598,133],[600,134],[601,134],[602,136],[604,137],[606,138],[610,139],[614,138]],
      ],
      countryCenter: { x: 615.5, y: 152 },
      countryCode: 'IRN',
      countryId: 79,
      countryName: 'Iran',
    },
    80: {
      countryBorder: [
        [[593,141],[595,142],[595,144],[594,145],[594,147],[596,150],[600,152],[601,154],[601,156],[602,156],[602,158],[604,159],[602,159],[600,159],[599,162],[594,162],[586,155],[582,153],[579,153],[578,149],[583,146],[583,142],[583,140],[584,139],[585,137],[586,137],[589,137],[590,138],[591,137]],
      ],
      countryCenter: { x: 591, y: 149.5 },
      countryCode: 'IRQ',
      countryId: 80,
      countryName: 'Iraq',
    },
    81: {
      countryBorder: [
        [[466,88],[466,90],[464,93],[460,95],[457,94],[459,91],[458,88],[461,86],[463,85],[463,86],[463,88],[464,88]],
      ],
      countryCenter: { x: 461.5, y: 90 },
      countryCode: 'IRL',
      countryId: 81,
      countryName: 'Ireland',
    },
    82: {
      countryBorder: [
        [[570,151],[570,152],[569,151],[568,153],[569,154],[569,154],[568,155],[570,155],[570,156],[569,161],[567,155],[567,154],[567,154],[568,153],[568,151],[568,150],[568,150],[569,150],[569,149],[570,149],[570,150],[570,151]],
      ],
      countryCenter: { x: 568.5, y: 156 },
      countryCode: 'ISR',
      countryId: 82,
      countryName: 'Israel',
    },
    83: {
      countryBorder: [
        [
          [518,134],[517,137],[518,138],[517,139],[515,138],[514,138],[510,136],[511,135],[514,135],[516,135],
          { c: { x: 514, y: 136.5, label: { x: 514, y: 136.5, countryName: 'Sicily' } } },
        ],
        [
          [502,125],[504,127],[503,131],[502,131],[501,132],[500,131],[500,128],[499,126],[501,126],
          { c: { x: 501.5, y: 128.5, label: { x: 501.5, y: 128.5, countryName: 'Sardinia' } } },
        ],
        [
          [512,110],[512,111],[513,112],[511,112],[509,113],[509,114],[509,115],[510,117],[512,118],[513,121],[516,123],[518,123],[519,124],[518,124],[521,125],[522,126],[525,128],[525,128],[525,130],[523,128],[521,128],[520,130],[522,131],[522,132],[521,132],[519,135],[518,135],[518,134],[519,133],[519,132],[518,130],[517,129],[516,128],[516,127],[514,127],[513,125],[511,125],[509,124],[507,122],[505,120],[504,117],[503,117],[501,116],[500,116],[498,118],[497,118],[498,117],[496,116],[496,114],[496,113],[496,112],[496,111],[497,112],[498,112],[499,111],[500,111],[501,111],[501,110],[503,110],[504,110],[504,108],[506,109],[506,108],[508,108],[509,109],
          { c: { x: 501.5, y: 122.5, label: { x: 505, y: 113.5, countryName: 'Italy' } } },
        ],
      ],
      countryCode: 'ITA',
      countryId: 83,
      countryName: 'Italy',
    },
    84: {
      countryBorder: [
        [[276,194],[278,194],[279,195],[279,196],[278,196],[277,196],[275,196],[274,195],[274,194],[275,194]]
      ],
      countryCenter: { x: 276.5, y: 195 },
      countryCode: 'JAM',
      countryId: 84,
      countryName: 'Jamaica',
    },
    85: {
      countryBorder: [
        [[819,147],[820,148],[819,149],[818,148],[817,149],[817,151],[815,150],[814,149],[815,147],[816,147],[817,146]],
        [[830,138],[831,140],[832,141],[832,144],[829,145],[825,145],[823,149],[820,147],[819,145],[815,146],[813,147],[810,147],[813,150],[814,155],[813,156],[811,155],[811,152],[809,151],[807,149],[809,148],[809,146],[811,145],[812,143],[817,142],[820,142],[820,137],[822,139],[824,135],[825,134],[824,131],[822,127],[822,125],[824,125],[828,129],[829,131],[829,134]],
        [[825,117],[827,117],[828,116],[831,119],[828,120],[827,123],[822,121],[823,124],[820,124],[818,121],[818,119],[820,119],[818,115],[817,112],[822,116]]
      ],
      countryCenter: { x: 822, y: 140.5 },
      countryCode: 'JPN',
      countryId: 85,
      countryName: 'Japan',
    },
    86: {
      countryBorder: [
        [[570,152],[570,151],[573,152],[578,149],[579,153],[579,153],[574,155],[577,158],[576,158],[575,159],[574,159],[573,161],[572,161],[569,161],[569,161],[570,156],[570,155],[570,154]]
      ],
      countryCenter: { x: 573, y: 158 },
      countryCode: 'JOR',
      countryId: 86,
      countryName: 'Jordan',
    },
    87: {
      countryBorder: [
        [[652,122],[650,123],[648,125],[647,127],[647,127],[645,126],[642,125],[641,123],[640,123],[639,120],[636,118],[632,118],[629,119],[626,116],[624,115],[619,113],[619,112],[613,114],[616,125],[615,125],[613,123],[611,122],[608,123],[607,124],[607,123],[607,122],[607,121],[603,120],[602,117],[600,116],[600,115],[602,116],[602,113],[604,113],[606,113],[606,110],[605,109],[602,109],[600,108],[598,109],[596,110],[594,109],[594,108],[592,106],[591,106],[588,104],[589,102],[588,101],[589,98],[592,100],[592,98],[595,94],[599,94],[605,96],[608,98],[610,96],[613,96],[617,98],[617,97],[621,97],[621,96],[616,94],[618,92],[617,91],[619,91],[617,89],[617,88],[625,87],[626,86],[631,85],[633,84],[637,84],[639,87],[641,87],[644,88],[645,89],[647,89],[651,86],[651,87],[655,89],[663,97],[664,95],[668,97],[671,96],[672,97],[674,98],[676,99],[678,100],[681,100],[683,102],[682,104],[680,104],[681,107],[680,108],[675,107],[676,112],[675,113],[671,114],[675,119],[673,120],[674,122],[673,122],[671,120],[667,120],[663,120],[662,120],[659,119],[657,120],[658,121],[653,120],[652,121]]
      ],
      countryCenter: { x: 635.5, y: 105.5 },
      countryCode: 'KAZ',
      countryId: 87,
      countryName: 'Kazakhstan',
    },
    88: {
      countryBorder: [
        [[590,255],[588,256],[588,257],[587,257],[586,259],[585,261],[585,263],[584,264],[580,261],[580,259],[570,253],[570,252],[570,249],[571,248],[572,246],[573,244],[572,240],[571,239],[570,237],[572,235],[573,233],[575,233],[575,235],[576,236],[578,236],[581,239],[582,239],[582,239],[583,239],[585,239],[586,238],[588,237],[589,238],[591,238],[589,241],[589,252]]
      ],
      countryCenter: { x: 580.5, y: 248.5 },
      countryCode: 'KEN',
      countryId: 88,
      countryName: 'Kenya',
    },
    89: {
      countryCenter: { x: 60.5, y: 243.5 },
      countryCode: 'KIR',
      countryId: 89,
      countryName: 'Kirabati',
    },
    90: {
      countryBorder: [
        [[530,123],[529,122],[528,121],[529,121],[529,119],[530,119],[530,120],[531,120],[532,121],[532,122],[531,122]]
      ],
      countryCenter: { x: 530, y: 122 },
      countryCode: 'XKX',
      countryId: 90,
      countryName: 'Kosovo',
    },
    91: {
      countryBorder: [
        [[652,122],[652,121],[653,120],[658,121],[657,120],[659,119],[662,120],[663,120],[667,120],[671,120],[673,122],[674,122],[674,123],[671,124],[670,125],[667,126],[667,128],[664,127],[663,128],[661,129],[661,130],[661,131],[656,131],[653,130],[650,130],[650,129],[653,129],[654,128],[656,129],[658,126],[655,125],[653,126],[651,124],[653,122]]
      ],
      countryCenter: { x: 662, y: 124 },
      countryCode: 'KGZ',
      countryId: 91,
      countryName: 'Kyrgyz Rep',
    },
    92: {
      countryBorder: [
        [[757,207],[758,205],[758,203],[755,200],[755,197],[752,195],[750,194],[750,195],[748,195],[748,195],[745,197],[745,194],[745,191],[743,191],[743,189],[741,188],[742,187],[744,185],[744,186],[745,186],[744,182],[746,182],[748,184],[749,187],[752,187],[754,190],[752,190],[752,191],[755,193],[758,197],[760,199],[762,202],[763,204],[763,207],[761,206],[760,208]]
      ],
      countryCenter: { x: 749, y: 192 },
      countryCode: 'LAO',
      countryId: 92,
      countryName: 'Laos',
    },
    93: {
      countryBorder: [
        [[526,82],[526,80],[527,78],[528,77],[531,79],[532,79],[532,77],[534,77],[535,77],[537,78],[539,78],[540,79],[541,80],[542,82],[539,83],[538,83],[536,82],[535,82],[534,81],[532,81],[528,81]]
      ],
      countryCenter: { x: 534, y: 80 },
      countryCode: 'LVA',
      countryId: 93,
      countryName: 'Latvia',
    },
    94: {
      countryBorder: [
        [[570,149],[569,149],[569,150],[568,150],[569,147],[570,145],[570,145],[571,145],[572,146],[571,148]]
      ],
      countryCenter: { x: 570, y: 147.5 },
      countryCode: 'LBN',
      countryId: 94,
      countryName: 'Lebanon',
    },
    95: {
      countryBorder: [
        [[459,236],[458,236],[456,235],[453,233],[451,231],[449,229],[450,228],[450,227],[451,226],[452,224],[453,224],[454,224],[455,226],[455,227],[455,227],[456,228],[456,226],[457,226],[457,227],[457,229],[457,230],[457,231],[458,231],[459,232],[459,234],[459,234]]
      ],
      countryCenter: { x: 454, y: 230 },
      countryCode: 'LBR',
      countryId: 95,
      countryName: 'Liberia',
    },
    96: {
      countryBorder: [
        [[518,181],[516,182],[515,180],[511,179],[510,177],[507,175],[506,176],[505,174],[505,173],[504,171],[505,170],[504,168],[505,166],[504,165],[505,162],[505,161],[504,158],[505,157],[505,156],[505,155],[507,154],[507,153],[509,152],[509,150],[512,151],[513,150],[515,151],[518,152],[520,155],[522,156],[526,157],[528,158],[530,157],[531,156],[530,154],[531,152],[532,151],[534,151],[538,151],[539,152],[539,152],[540,153],[543,153],[544,154],[543,156],[543,157],[543,159],[544,161],[544,172],[545,183],[545,189],[542,189],[542,191],[531,185],[521,179]]
      ],
      countryCenter: { x: 524.5, y: 170.5 },
      countryCode: 'LBY',
      countryId: 96,
      countryName: 'Libya',
    },
    97: {
      countryBorder: [
        [[530,87],[530,86],[530,85],[529,85],[527,84],[526,82],[528,81],[532,81],[534,81],[535,82],[536,82],[538,83],[539,84],[537,85],[537,87],[534,88],[532,88],[532,87]]
      ],
      countryCenter: { x: 532.5, y: 84.5 },
      countryCode: 'LTU',
      countryId: 97,
      countryName: 'Lithuania',
    },
    98: {
      countryBorder: [
        [[494,99],[494,100],[494,101],[493,101],[493,101],[493,99]]
      ],
      countryCenter: { x: 493.5, y: 101.7 },
      countryCode: 'LUX',
      countryId: 98,
      countryName: 'Luxembourg',
    },
    99: {
      countryBorder: [
        [[611,287],[611,288],[612,290],[612,294],[613,295],[612,297],[612,298],[611,296],[610,297],[611,299],[610,300],[610,301],[609,304],[608,307],[606,311],[604,317],[603,321],[602,325],[599,325],[597,327],[596,326],[594,325],[593,323],[593,321],[592,318],[592,316],[593,314],[594,313],[594,312],[596,310],[596,308],[595,307],[595,305],[595,302],[596,300],[597,298],[598,298],[599,298],[600,297],[602,297],[603,295],[605,294],[606,292],[606,291],[607,291],[609,289],[609,287],[610,286]]
      ],
      countryCenter: { x: 602.5, y: 306.5 },
      countryCode: 'MDG',
      countryId: 99,
      countryName: 'Madagascar',
    },
    100: {
      countryBorder: [
        [[571,284],[570,287],[571,291],[572,290],[573,291],[574,294],[574,297],[573,298],[572,300],[570,298],[570,296],[571,295],[570,294],[569,293],[569,293],[567,292],[566,291],[567,288],[568,287],[567,285],[568,282],[568,281],[568,279],[566,277],[569,278],[570,279],[570,280]]
      ],
      countryCenter: { x: 570, y: 288.5 },
      countryCode: 'MWI',
      countryId: 100,
      countryName: 'Malawi',
    },
    101: {
      countryBorder: [
        [[751,231],[752,231],[753,233],[755,235],[755,237],[755,238],[755,239],[755,241],[756,242],[757,245],[757,245],[757,246],[756,246],[755,246],[753,244],[750,241],[749,240],[748,238],[747,235],[746,234],[746,231],[746,230],[746,230],[748,231],[749,232],[750,232]],
        [[793,237],[791,237],[788,237],[787,240],[786,241],[785,245],[783,246],[780,245],[779,245],[777,247],[776,247],[774,247],[772,246],[772,243],[774,245],[776,244],[776,241],[777,241],[780,240],[782,238],[783,236],[785,237],[785,236],[787,237],[787,235],[787,233],[789,231],[790,229],[791,229],[792,230],[792,231],[794,232],[797,233],[796,234],[795,235],[795,236]]
      ],
      countryCenter: { x: 766.3, y: 242 },
      countryCode: 'MYS',
      countryId: 101,
      countryName: 'Malaysia',
    },
    102: {
      countryBorder: [
        [
          [675,240],
          { c: { x: 675, y: 240 } }
        ],
        [
          [675,237],
          { c: { x: 675, y: 237 } }
        ]
      ],
      countryCode: 'MDV',
      countryId: 102,
      countryName: 'Maldives',
      labelCenter: { x: 675, y: 238.5 }
    },
    103: {
      countryBorder: [
        [[447,205],[448,205],[449,203],[450,203],[451,204],[453,203],[454,204],[454,203],[465,203],[466,201],[465,200],[464,187],[463,174],[467,174],[476,181],[484,187],[485,189],[487,190],[488,190],[488,192],[491,192],[491,199],[489,201],[489,203],[487,203],[483,203],[482,204],[481,205],[479,205],[478,204],[477,204],[474,206],[474,207],[472,208],[471,209],[470,209],[469,209],[468,210],[468,212],[466,214],[466,215],[465,217],[465,218],[464,219],[464,219],[463,218],[462,218],[462,218],[461,219],[459,219],[459,218],[458,219],[457,218],[458,217],[457,217],[457,217],[457,216],[457,215],[456,214],[456,213],[455,212],[455,212],[454,213],[453,213],[453,214],[452,214],[451,213],[450,213],[450,213],[449,213],[449,212],[449,211],[449,210],[448,209],[448,207]]
      ],
      countryCenter: { x: 469, y: 196.5 },
      countryCode: 'MLI',
      countryId: 103,
      countryName: 'Mali',
    },
    104: {
      countryCenter: { x: 515.5, y: 141.5 },
      countryCode: 'MLT',
      countryId: 104,
      countryName: 'Malta',
    },
    105: {
      countryBorder: [
        [[447,205],[446,203],[444,201],[442,200],[441,199],[440,200],[438,200],[437,200],[436,201],[436,199],[437,198],[437,195],[437,192],[437,190],[437,189],[436,188],[435,186],[436,185],[446,185],[445,181],[446,179],[449,179],[449,171],[457,172],[457,167],[467,174],[463,174],[464,187],[465,200],[466,201],[465,203],[454,203],[454,204],[453,203],[451,204],[450,203],[449,203],[448,205]]
      ],
      countryCenter: { x: 451, y: 186 },
      countryCode: 'MRT',
      countryId: 105,
      countryName: 'Mauritania',
    },
    106: {
      countryBorder: [
        [[630,311],[630,311],[630,311],[629,311],[629,311],[629,311],[630,311],[630,310],[630,310],[630,310],[630,310],[630,310],[631,310],[631,311],[631,311],[630,311],[630,311]]
      ],
      countryCenter: { x: 630, y: 310.5 },
      countryCode: 'MUS',
      countryId: 106,
      countryName: 'Mauritius',
    },
    107: {
      countryBorder: [
        [[248,194],[247,194],[246,196],[246,195],[245,195],[245,196],[243,196],[241,196],[240,198],[239,198],[240,199],[241,199],[241,200],[242,200],[241,201],[238,201],[236,204],[237,204],[236,205],[236,206],[234,202],[232,201],[230,201],[229,201],[226,202],[225,202],[223,202],[221,201],[219,200],[217,199],[214,198],[212,196],[212,196],[210,195],[208,194],[207,193],[205,191],[204,189],[203,188],[204,188],[204,187],[205,186],[205,185],[204,184],[204,182],[204,181],[202,178],[200,176],[199,174],[197,172],[196,172],[197,170],[196,169],[195,168],[195,166],[194,165],[192,164],[192,162],[192,161],[191,159],[191,157],[191,156],[190,154],[189,154],[188,154],[187,155],[187,156],[186,159],[187,160],[188,162],[188,163],[189,163],[189,164],[189,164],[189,166],[190,167],[190,168],[191,169],[192,172],[192,173],[192,175],[192,176],[194,176],[194,178],[195,179],[195,180],[194,181],[193,181],[193,179],[191,177],[190,176],[189,175],[189,173],[189,171],[188,170],[187,169],[186,169],[186,168],[184,168],[183,166],[184,166],[185,166],[186,165],[186,163],[185,161],[184,160],[183,159],[183,157],[183,154],[183,151],[186,151],[189,151],[188,151],[192,153],[197,155],[202,155],[204,155],[204,154],[209,154],[209,155],[210,156],[211,157],[212,159],[212,160],[213,161],[215,162],[217,160],[219,160],[221,161],[222,163],[222,165],[223,166],[223,169],[224,170],[226,171],[227,172],[228,172],[227,174],[226,176],[225,180],[225,182],[225,184],[225,185],[226,187],[227,190],[227,191],[228,193],[231,194],[232,195],[234,194],[236,194],[238,193],[240,193],[242,191],[243,190],[243,187],[244,186],[246,185],[248,185],[251,185],[252,185],[253,185],[253,187],[251,188],[250,190],[251,191],[250,192],[249,194],[248,194]]
      ],
      countryCenter: { x: 215, y: 178.5 },
      countryCode: 'MEX',
      countryId: 107,
      countryName: 'Mexico',
    },
    108: {
      countryBorder: [
        [
          [913,233.5],
          { c: { x: 913, y: 233.5 } }
        ],
        [
          [900,229],
          { c: { x: 900, y: 229 } }
        ],
        [
          [882,227],
          { c: { x: 882, y: 227 } }
        ],
        [
          [883,227],
          { c: { x: 883, y: 227 } }
        ],
      ],
      countryName: 'Micronesia',
      countryCode: 'FSM',
      countryId: 108,
      labelCenter: { x: 900, y: 229 }
    },
    109: {
      countryBorder: [
        [[542,105],[542,104],[544,104],[546,105],[547,105],[548,106],[548,107],[549,107],[549,108],[550,109],[550,110],[551,110],[550,110],[549,110],[548,110],[548,110],[548,110],[548,111],[547,112],[547,113],[546,111],[546,110],[546,109],[544,107],[543,106],[543,105]]
      ],
      countryCenter: { x: 548, y: 107 },
      countryCode: 'MDA',
      countryId: 109,
      countryName: 'Moldova',
    },
    110: {
      countryBorder: [
        [[683,101],[686,101],[689,98],[692,97],[694,98],[696,98],[699,99],[701,99],[705,100],[706,98],[704,96],[705,93],[708,95],[710,95],[713,96],[715,98],[719,99],[721,99],[724,98],[726,99],[729,100],[732,101],[734,101],[737,102],[739,101],[741,101],[743,99],[745,99],[747,100],[750,100],[750,102],[750,105],[751,106],[752,106],[755,106],[756,105],[759,106],[762,108],[762,109],[760,109],[757,109],[756,110],[755,112],[752,113],[751,115],[748,114],[746,114],[746,116],[748,117],[749,118],[747,119],[746,120],[744,121],[741,122],[737,123],[735,124],[734,123],[731,123],[726,121],[724,121],[721,121],[715,121],[713,121],[710,119],[708,116],[706,116],[703,114],[699,114],[696,113],[695,112],[694,108],[692,106],[688,105],[685,103]]
      ],
      countryCenter: { x: 722.5, y: 108.5 },
      countryCode: 'MNG',
      countryId: 110,
      countryName: 'Mongolia',
    },
    111: {
      countryBorder: [
        [[527,121],[526,122],[527,123],[526,123],[525,122],[524,122],[524,121],[525,119],[525,119],[526,118],[527,119],[527,119],[528,120],[529,120],[529,121],[528,121],[528,122]]
      ],
      countryCenter: { x: 526.5, y: 120 },
      countryCode: 'MNE',
      countryId: 111,
      countryName: 'Montenegro',
      labelCenter: { x: 523, y: 119.5 },
    },
    112: {
      countryBorder: [
        [[474,143],[475,145],[475,147],[476,150],[477,151],[476,152],[473,153],[472,154],[470,154],[470,156],[467,158],[466,159],[464,160],[461,160],[457,163],[457,166],[446,166],[448,165],[452,163],[453,162],[455,159],[455,156],[456,153],[456,151],[458,149],[460,148],[462,147],[464,144],[465,142],[467,142],[468,143],[470,143],[473,143]]
      ],
      countryCenter: { x: 461.5, y: 154 },
      countryCode: 'MAR',
      countryId: 112,
      countryName: 'Morocco',
    },
    113: {
      countryBorder: [
        [[571,284],[573,284],[576,285],[577,285],[579,284],[580,284],[581,284],[584,282],[586,281],[587,282],[587,285],[587,288],[587,292],[587,294],[586,296],[585,298],[583,300],[581,301],[578,303],[575,306],[574,306],[572,309],[571,309],[570,311],[571,314],[572,315],[572,316],[572,316],[572,319],[572,321],[572,321],[572,322],[570,323],[568,324],[565,326],[564,327],[564,328],[565,329],[564,330],[562,330],[562,329],[562,327],[562,326],[562,323],[562,321],[561,317],[564,313],[565,311],[565,311],[565,309],[565,308],[565,306],[566,304],[566,300],[565,299],[563,299],[563,298],[562,297],[559,297],[559,296],[559,294],[567,292],[569,293],[569,293],[570,294],[571,295],[570,296],[570,298],[572,300],[573,298],[574,297],[574,294],[573,291],[572,290],[571,291],[570,287]]
      ],
      countryCenter: { x: 573, y: 305.5 },
      countryCode: 'MOZ',
      countryId: 113,
      countryName: 'Mozambique',
    },
    114: {
      countryBorder: [
        [[741,220],[740,217],[741,215],[740,213],[740,210],[739,208],[737,205],[737,201],[735,198],[734,200],[731,202],[729,202],[728,201],[728,197],[727,195],[725,191],[725,190],[723,190],[721,187],[720,185],[721,185],[721,183],[722,182],[722,181],[722,180],[722,177],[724,178],[725,175],[725,174],[726,171],[725,169],[728,167],[730,168],[729,166],[730,165],[730,164],[731,164],[732,166],[734,167],[734,169],[735,171],[733,174],[733,177],[736,177],[737,180],[739,180],[738,183],[740,184],[742,185],[743,184],[744,185],[742,187],[741,188],[740,189],[739,190],[737,190],[736,193],[735,194],[737,197],[739,199],[740,201],[739,203],[738,204],[739,205],[741,208],[742,210],[742,211],[743,214],[742,216]]
      ],
      countryCenter: { x: 732, y: 192 },
      countryCode: 'MMR',
      countryId: 114,
      countryName: 'Myanmar',
      labelCenter: { x: 730, y: 187 },
    },
    115: {
      countryBorder: [
        [[522,336],[520,333],[519,331],[518,328],[518,326],[517,321],[517,318],[517,316],[516,315],[514,312],[513,309],[513,307],[511,304],[510,302],[512,301],[513,301],[515,301],[516,302],[517,302],[528,302],[529,303],[536,304],[541,302],[543,302],[544,302],[545,303],[545,303],[544,303],[543,303],[541,305],[540,303],[536,304],[534,305],[534,315],[531,315],[531,324],[531,335],[528,337],[527,337],[525,337],[524,336],[524,335],[523,334]]
      ],
      countryCenter: { x: 524, y: 313 },
      countryCode: 'NAM',
      countryId: 115,
      countryName: 'Namibia',
    },
    116: {
      countryCenter: { x: 924, y: 251 },
      countryCode: 'NRU',
      countryId: 116,
      countryName: 'Nauru',
    },
    117: {
      countryBorder: [
        [[706,165],[706,167],[707,169],[707,170],[705,170],[702,169],[700,169],[698,167],[694,167],[691,165],[688,164],[685,163],[686,160],[687,159],[688,158],[690,159],[693,161],[695,161],[696,163],[698,163],[700,164],[703,165]]
      ],
      countryCenter: { x: 696, y: 164 },
      countryCode: 'NPL',
      countryId: 117,
      countryName: 'Nepal',
    },
    118: {
      countryBorder: [
        [[495,89],[496,90],[495,93],[495,94],[493,94],[494,97],[492,96],[491,95],[489,96],[487,95],[488,95],[490,90],[493,89]]
      ],
      countryCenter: { x: 491.5, y: 91 },
      countryCode: 'NLD',
      countryId: 118,
      countryName: 'Netherlands',
    },
    119: {
      countryBorder: [
        [[912,313],[914,315],[915,316],[914,317],[913,316],[911,315],[910,313],[909,311],[909,310],[910,310],[911,311],[912,312]]
      ],
      countryCenter: { x: 912, y: 313.5 },
      countryCode: 'NCL',
      countryId: 119,
      countryName: 'New Caledonia',
    },
    120: {
      countryBorder: [
        [[902,373],[902,374],[905,373],[904,374],[903,375],[901,377],[898,379],[896,380],[896,382],[894,382],[891,383],[888,385],[885,388],[882,389],[880,390],[878,390],[877,389],[875,389],[875,388],[878,385],[883,382],[885,382],[888,381],[891,379],[894,378],[897,375],[898,375],[900,373],[903,372]],
        [[916,359],[916,362],[917,360],[918,361],[917,363],[918,364],[919,364],[922,363],[923,363],[920,366],[918,368],[916,368],[915,368],[914,370],[914,370],[912,372],[909,374],[906,375],[906,374],[905,374],[909,372],[909,370],[907,369],[908,368],[911,367],[913,364],[914,362],[914,360],[914,360],[914,358],[914,356],[914,354],[915,353],[915,355],[917,356]],
      ],
      countryCenter: { x: 902, y: 373 },
      countryCode: 'NZL',
      countryId: 120,
      countryName: 'New Zealand',
    },
    121: {
      countryBorder: [
        [[252,216],[252,215],[251,214],[250,213],[249,212],[248,211],[248,210],[248,211],[249,210],[250,210],[250,210],[250,210],[250,208],[251,208],[252,208],[252,207],[253,208],[253,207],[254,207],[255,206],[255,206],[255,206],[256,205],[256,205],[256,205],[257,205],[257,205],[258,205],[259,205],[259,204],[260,204],[260,205],[260,205],[260,206],[259,207],[259,209],[259,210],[259,211],[259,212],[258,212],[258,214],[258,214],[257,215],[258,216],[258,217],[257,217],[256,217],[256,216],[255,216],[255,217],[253,216]]
      ],
      countryCenter: { x: 254, y: 211.5 },
      countryCode: 'NIC',
      countryId: 121,
      countryName: 'Nicaragua',
    },
    122: {
      countryBorder: [
        [[485,214],[485,211],[482,211],[482,209],[481,207],[480,206],[481,205],[482,204],[483,203],[487,203],[489,203],[489,201],[491,199],[491,192],[494,190],[502,185],[511,179],[515,180],[516,182],[518,181],[519,185],[520,186],[520,187],[521,188],[521,189],[520,195],[520,199],[516,202],[515,206],[516,207],[516,209],[518,209],[518,211],[517,211],[517,212],[517,212],[515,209],[514,209],[512,210],[510,209],[509,209],[508,210],[506,210],[505,211],[503,211],[500,209],[499,210],[498,210],[497,209],[494,208],[491,208],[490,209],[490,210],[489,212],[489,214],[487,213],[486,213]]
      ],
      countryCenter: { x: 500.5, y: 196.5 },
      countryCode: 'NER',
      countryId: 122,
      countryName: 'Niger',
    },
    123: {
      countryBorder: [
        [[502,235],[499,236],[498,236],[497,237],[495,237],[494,235],[493,233],[491,231],[489,231],[487,231],[487,226],[487,224],[487,222],[488,221],[489,219],[489,218],[490,217],[489,215],[489,214],[489,212],[490,210],[490,209],[491,208],[494,208],[497,209],[498,210],[499,210],[500,209],[503,211],[505,211],[506,210],[508,210],[509,209],[510,209],[512,210],[514,209],[515,209],[517,212],[517,212],[518,213],[518,214],[518,215],[516,217],[515,219],[514,220],[514,221],[513,223],[512,225],[512,226],[511,227],[511,228],[509,230],[507,228],[506,228],[505,230],[504,230],[503,233]]
      ],
      countryCenter: { x: 502.5, y: 222.5 },
      countryCode: 'NGA',
      countryId: 123,
      countryName: 'Nigeria',
    },
    124: {
      countryBorder: [
        [[796,122],[797,122],[796,122],[795,123],[795,124],[797,126],[796,127],[795,128],[795,128],[794,129],[793,130],[794,131],[793,131],[795,132],[797,133],[797,134],[796,134],[794,134],[794,136],[793,135],[793,136],[791,135],[791,136],[791,136],[790,135],[789,135],[789,135],[789,133],[789,133],[788,132],[788,131],[788,130],[786,130],[785,129],[786,127],[788,126],[788,124],[790,124],[792,125],[791,123],[794,122],[794,120]]
      ],
      countryCenter: { x: 791, y: 130 },
      countryCode: 'PRK',
      countryId: 124,
      countryName: 'DPR. N. Korea',
    },
    125: {
      countryBorder: [
        [[530,123],[530,123],[530,123],[531,122],[532,122],[533,122],[534,122],[535,123],[536,125],[535,125],[535,126],[533,126],[533,126],[531,126],[530,126],[529,124]]
      ],
      countryCenter: { x: 532.5, y: 124 },
      countryCode: 'MKD',
      countryId: 125,
      countryName: 'N. Macedonia',
      labelCenter: { x: 528, y: 124.5 },
    },
    126: {
      countryBorder: [
        [[667,138],[669,139],[670,141],[675,143],[673,145],[670,145],[666,145],[665,146],[667,149],[668,151],[671,152],[669,154],[669,156],[667,159],[666,162],[664,165],[661,165],[659,168],[661,170],[661,172],[663,174],[664,176],[658,176],[657,178],[655,177],[654,175],[651,173],[647,173],[643,173],[639,174],[639,170],[643,169],[643,167],[641,167],[641,164],[638,163],[637,161],[635,160],[640,161],[642,161],[644,161],[644,160],[646,161],[649,159],[649,157],[650,155],[652,155],[652,154],[654,154],[655,154],[656,153],[655,152],[656,150],[657,149],[656,147],[658,147],[659,146],[658,145],[659,144],[659,142],[658,141],[659,139],[661,139],[664,138],[665,138]]
      ],
      countryCenter: { x: 655, y: 158 },
      countryCode: 'PAK',
      countryId: 126,
      countryName: 'Pakistan',
      labelCenter: { x: 657, y: 160 },
    },
    127: {
      countryBorder: [
        [
          [570,152],[570,154],[570,155],[568,155],[569,154],[569,154],[568,153],[569,151],
          { c: { x: 569, y: 153, label: { x: 569, y: 152, countryName: 'West Bank' } } }
        ],
        [
          [567,155],[568,155],[568,153],[567,154],[567,155],
          { c: { x: 567.5, y: 154, label: { x: 567.5, y: 154, countryName: 'Gaza' } } }
        ],
      ],
      countryCode: 'PSE',
      countryId: 127,
      countryName: 'West Bank & Gaza',
    },
    128: {
      countryBorder: [
        [[273,228],[272,227],[271,225],[272,224],[271,224],[271,223],[270,222],[268,223],[268,224],[267,224],[266,225],[266,225],[267,227],[266,227],[266,228],[265,228],[264,226],[264,226],[263,226],[263,225],[261,225],[261,225],[260,225],[260,225],[259,225],[259,224],[260,224],[260,223],[260,223],[259,222],[260,221],[261,221],[261,222],[261,222],[262,223],[263,222],[263,223],[265,223],[266,222],[268,221],[268,221],[270,221],[270,221],[271,221],[272,222],[273,223],[274,223],[274,224],[274,226],[274,227],[273,226]]
      ],
      countryCenter: { x: 268, y: 224.5 },
      countryCode: 'PAN',
      countryId: 128,
      countryName: 'Panama',
    },
    129: {
      countryBorder: [
        [[894,270],[893,270],[892,269],[891,267],[891,265],[891,265],[891,266],[892,266],[893,268],[894,269]],
        [[884,266],[882,266],[882,267],[880,268],[879,269],[878,269],[875,268],[874,267],[874,266],[877,266],[878,266],[879,265],[879,265],[879,266],[881,266],[881,265],[883,264],[883,262],[884,262],[885,263],[885,264]],
        [[854,277],[855,267],[855,257],[860,259],[864,261],[866,263],[868,264],[868,266],[872,268],[873,269],[870,270],[871,272],[873,274],[874,277],[876,277],[876,278],[878,279],[877,279],[879,281],[879,281],[877,282],[877,281],[874,281],[872,280],[870,278],[869,277],[867,274],[864,273],[862,273],[860,274],[860,277],[858,278],[857,277]],
        [[887,263],[886,264],[886,262],[885,261],[884,260],[883,259],[881,258],[881,257],[883,258],[884,259],[885,259],[886,261],[887,262]]
      ],
      countryCenter: { x: 879.5, y: 267 },
      countryCode: 'PNG',
      countryId: 129,
      countryName: 'Papua New Guinea',
    },
    130: {
      countryBorder: [
        [[316,317],[317,313],[317,311],[318,309],[322,308],[325,308],[327,309],[327,310],[328,312],[329,316],[331,317],[332,316],[334,317],[335,318],[335,321],[336,322],[337,322],[338,321],[339,322],[339,324],[339,325],[338,327],[338,330],[336,332],[334,333],[331,332],[328,331],[330,327],[330,325],[327,324],[324,322],[321,322]]
      ],
      countryCenter: { x: 327.5, y: 320.5 },
      countryCode: 'PRY',
      countryId: 130,
      countryName: 'Paraguay',
    },
    131: {
      countryBorder: [
        [[297,303],[296,304],[295,305],[292,303],[292,302],[286,299],[281,296],[279,294],[278,291],[278,290],[276,286],[273,281],[270,275],[269,273],[268,271],[265,269],[264,268],[264,267],[263,264],[264,262],[266,260],[266,261],[265,262],[265,263],[267,263],[268,263],[269,265],[270,263],[271,261],[272,259],[275,257],[278,254],[279,252],[279,250],[279,250],[281,251],[282,253],[283,253],[285,257],[287,257],[288,256],[289,257],[291,256],[293,258],[291,261],[292,261],[294,263],[291,262],[291,263],[289,263],[286,265],[286,267],[285,268],[285,270],[284,270],[284,272],[283,272],[284,275],[286,277],[285,278],[287,278],[288,280],[290,280],[293,278],[293,283],[294,283],[295,283],[298,287],[297,288],[297,291],[298,293],[297,295],[297,296],[297,297],[298,299]]
      ],
      countryCenter: { x: 280.5, y: 277.5 },
      countryCode: 'PER',
      countryId: 131,
      countryName: 'Peru',
    },
    132: {
      countryBorder: [
        [[815,224],[815,226],[816,228],[815,231],[814,228],[813,229],[814,231],[813,233],[810,231],[809,229],[810,227],[808,226],[807,227],[806,227],[804,229],[803,228],[804,225],[806,224],[807,223],[808,225],[810,224],[811,223],[813,222],[812,220],[814,222],[815,223]],
        [[808,219],[807,220],[807,221],[806,222],[804,220],[805,219],[805,219],[805,217],[807,217],[807,219],[808,216]],
        [[794,221],[791,224],[792,222],[794,220],[795,218],[796,215],[797,218],[795,219]],
        [[802,214],[804,215],[806,215],[806,216],[805,217],[803,218],[803,217],[803,215]],
        [[812,213],[813,216],[811,215],[811,216],[812,218],[810,219],[810,217],[809,217],[809,215],[810,215],[810,214],[808,212],[811,212]],
        [[801,210],[800,213],[799,211],[797,209],[800,209]],
        [[798,194],[800,195],[800,194],[801,195],[800,196],[802,198],[801,201],[800,202],[800,204],[801,206],[802,207],[803,206],[807,208],[807,210],[808,210],[808,212],[806,210],[804,209],[804,210],[802,208],[800,208],[798,208],[798,207],[799,206],[798,205],[798,206],[796,204],[796,203],[795,200],[796,201],[796,196],[796,194]]
      ],
      countryCenter: { x: 804, y: 216 },
      countryCode: 'PHL',
      countryId: 132,
      countryName: 'Phillipines',
    },
    133: {
      countryBorder: [
        [[514,96],[513,94],[513,93],[512,92],[511,91],[512,90],[511,88],[513,88],[516,86],[519,85],[521,86],[521,87],[523,87],[526,87],[530,87],[532,87],[532,88],[533,89],[533,90],[533,92],[532,92],[533,93],[533,95],[535,97],[535,98],[534,98],[532,101],[533,102],[532,102],[530,101],[528,101],[527,101],[526,102],[524,101],[523,101],[523,101],[522,99],[520,99],[520,98],[518,98],[518,99],[517,98],[517,97],[515,97]],
      ],
      countryCenter: { x: 523, y: 93.5 },
      countryCode : 'POL',
      countryId: 133,
      countryName: 'Poland',
    },
    134: {
      countryBorder: [
        [[458,123],[458,123],[460,122],[460,124],[461,124],[462,123],[463,123],[464,125],[463,126],[463,128],[462,128],[462,130],[461,130],[462,132],[461,134],[462,135],[462,136],[461,137],[461,138],[460,138],[459,138],[457,138],[458,136],[458,134],[457,134],[456,133],[456,131],[457,130],[458,128],[458,127],[458,125],[458,124]],
      ],
      countryCenter: { x: 460, y: 130 },
      countryCode : 'PRT',
      countryId: 134,
      countryName: 'Portugal',
    },
    135: {
      countryBorder: [
        [[306,194],[307,194],[307,195],[307,195],[305,195],[303,195],[303,194],[304,194]],
      ],
      countryCenter: { x: 305, y: 194.5 },
      countryCode : 'PRI',
      countryId: 135,
      countryName: 'Puerto Rico',
      labelCenter: { x: 301, y: 195.5 },
    },
    136: {
      countryBorder: [
        [[533,106],[534,105],[535,105],[537,105],[538,106],[539,106],[540,105],[541,105],[542,105],[543,105],[543,106],[544,107],[546,109],[546,110],[546,111],[547,113],[548,113],[549,113],[550,113],[550,114],[549,115],[548,114],[548,118],[547,118],[545,117],[542,117],[541,118],[538,118],[536,117],[535,118],[534,116],[533,116],[534,115],[533,115],[533,116],[531,115],[531,114],[529,113],[529,112],[527,111],[529,110],[531,108],[531,106]],
      ],
      countryCenter: { x: 538.5, y: 111.5 },
      countryCode: 'ROU',
      countryId: 136,
      countryName: 'Romania',
    },
    137: {
      countryBorder: [
        [[810,97],[816,102],[812,101],[814,106],[818,109],[820,111],[817,109],[817,111],[815,109],[813,106],[810,103],[809,100],[806,97],[802,94],[799,90],[800,88],[798,87],[799,87],[801,89],[804,91],[806,94]],
        [[530,87],[526,87],[523,87],[524,85],[527,84],[529,85],[530,85],[530,86]],
        [[131,53],[132,54],[134,52],[139,52],[139,55],[136,56],[132,56],[128,59],[127,59],[125,59],[125,58],[123,58],[124,56],[123,56],[120,56],[120,55],[122,54],[119,55],[118,56],[115,57],[131,47],[133,49],[134,52]],
        [[821,42],[819,42],[817,42],[818,41]],
        [[141,42],[138,42],[141,41],[142,41],[143,41],[145,41],[144,42]],
        [[743,36],[741,37],[737,36],[736,36],[736,35],[738,35],[742,36]],
        [[750,32],[749,33],[746,33],[741,32],[740,31],[744,31]],
        [[738,31],[739,33],[732,33],[730,33],[724,32],[723,30],[724,30],[729,30]],
        [[589,43],[588,43],[581,43],[580,41],[577,41],[576,39],[577,39],[576,38],[579,35],[577,35],[580,33],[579,32],[582,31],[587,29],[593,29],[595,28],[598,28],[600,29],[600,29],[594,31],[590,32],[585,34],[584,36],[583,39],[584,41]],
        [[795,120],[796,120],[795,117],[792,114],[794,113],[797,114],[797,111],[795,108],[796,106],[795,104],[792,105],[790,106],[787,106],[784,103],[780,101],[775,100],[772,97],[770,95],[768,94],[765,91],[762,90],[758,89],[755,89],[753,90],[752,91],[754,92],[755,94],[754,95],[754,98],[755,99],[753,101],[750,100],[747,100],[745,99],[743,99],[741,101],[739,101],[737,102],[734,101],[732,101],[729,100],[726,99],[724,98],[721,99],[719,99],[715,98],[713,96],[710,95],[708,95],[705,93],[704,96],[706,98],[705,100],[701,99],[699,99],[696,98],[694,98],[692,97],[689,98],[686,101],[683,101],[683,102],[681,100],[678,100],[676,99],[674,98],[672,97],[671,96],[668,97],[664,95],[663,97],[655,89],[651,87],[651,86],[647,89],[645,89],[644,88],[641,87],[639,87],[637,84],[633,84],[631,85],[626,86],[625,87],[617,88],[617,89],[619,91],[617,91],[618,92],[616,94],[621,96],[621,97],[617,97],[617,98],[613,96],[610,96],[608,98],[605,96],[599,94],[595,94],[592,98],[592,100],[589,98],[588,101],[589,102],[588,104],[591,106],[592,106],[594,108],[594,109],[596,110],[595,112],[593,112],[591,115],[594,118],[594,120],[598,124],[597,125],[596,126],[595,125],[593,124],[592,123],[591,123],[590,121],[587,121],[586,121],[585,121],[582,119],[578,119],[576,118],[576,119],[572,116],[569,115],[567,113],[569,113],[570,110],[569,109],[572,108],[572,107],[570,108],[569,107],[570,106],[573,106],[573,105],[572,103],[573,101],[572,101],[569,100],[567,100],[566,98],[564,99],[561,98],[561,97],[560,96],[558,96],[558,95],[558,94],[556,93],[554,93],[553,93],[553,93],[552,93],[551,91],[550,90],[551,90],[553,90],[553,90],[552,89],[551,88],[551,88],[550,87],[548,85],[548,85],[548,83],[546,83],[545,83],[544,82],[542,82],[541,80],[540,79],[539,78],[540,77],[539,74],[540,73],[539,72],[541,71],[539,70],[543,66],[544,64],[545,63],[541,61],[542,59],[539,57],[540,55],[537,52],[538,50],[535,49],[535,47],[536,47],[539,46],[541,45],[545,46],[550,47],[559,50],[560,51],[561,53],[559,54],[556,55],[547,53],[546,53],[549,55],[550,56],[551,59],[554,60],[555,60],[555,59],[554,58],[555,57],[560,59],[562,58],[560,56],[563,53],[565,54],[567,55],[568,53],[566,51],[566,50],[564,48],[570,49],[572,50],[569,51],[570,52],[572,53],[575,52],[574,51],[578,50],[584,47],[585,47],[584,49],[587,49],[588,48],[591,48],[594,47],[597,49],[598,47],[595,46],[596,45],[602,46],[605,46],[614,49],[614,48],[611,47],[611,46],[608,46],[608,45],[606,43],[606,42],[608,40],[607,37],[608,37],[614,38],[615,39],[615,41],[616,42],[618,43],[620,47],[623,48],[623,50],[622,54],[624,54],[625,53],[626,53],[626,51],[627,50],[625,49],[625,47],[622,47],[621,45],[621,43],[617,41],[619,39],[617,37],[618,37],[620,39],[621,41],[624,42],[622,40],[624,39],[628,39],[632,40],[629,38],[627,35],[629,35],[634,35],[638,35],[635,34],[636,32],[638,32],[640,31],[644,30],[644,30],[649,30],[651,30],[653,29],[656,29],[656,28],[656,27],[659,26],[663,27],[661,27],[666,28],[668,29],[669,28],[674,28],[679,29],[682,30],[683,31],[682,32],[679,33],[678,34],[681,35],[684,35],[685,35],[688,36],[688,36],[690,35],[697,36],[699,37],[707,37],[704,35],[709,36],[712,36],[716,37],[719,38],[719,39],[724,41],[728,42],[727,40],[731,41],[734,40],[738,41],[739,40],[742,41],[738,38],[739,37],[758,39],[762,40],[769,42],[776,42],[781,42],[784,43],[786,45],[790,46],[792,45],[795,45],[799,46],[802,45],[809,48],[810,47],[806,45],[805,44],[813,45],[816,45],[824,46],[828,47],[844,57],[844,57],[843,59],[840,58],[844,60],[848,62],[850,63],[852,64],[852,65],[848,64],[845,66],[843,66],[842,68],[842,70],[842,71],[837,69],[834,71],[832,70],[831,72],[828,71],[829,73],[830,76],[831,77],[834,78],[839,82],[837,82],[838,84],[841,85],[838,87],[841,90],[838,91],[840,94],[839,96],[837,94],[832,90],[824,84],[821,80],[821,78],[820,77],[823,76],[822,73],[823,70],[824,68],[821,64],[819,64],[820,66],[818,69],[813,66],[808,67],[808,72],[812,73],[808,74],[805,74],[803,72],[799,72],[798,73],[791,73],[785,74],[783,79],[781,86],[785,86],[787,88],[790,88],[790,87],[793,87],[799,90],[801,93],[802,96],[804,99],[807,104],[806,108],[807,110],[806,114],[805,117],[805,119],[802,121],[801,121],[799,119],[797,121],[797,122],[796,122]],
        [[659,25],[650,26],[649,23],[650,22],[652,23],[658,24]],
        [[563,20],[561,20],[560,20],[560,21],[558,21],[556,21],[557,20],[553,20],[556,20],[559,20],[559,20],[560,20],[561,19],[564,20]],
        [[648,23],[645,24],[639,23],[636,22],[632,21],[630,20],[632,19],[635,19],[640,20],[646,22]]
      ],
      countryCenter: { x: 693.5, y: 76 },
      countryCode: 'RUS',
      countryId: 137,
      countryName: 'Russia',
    },
    138: {
      countryBorder: [
        [[561,253],[562,255],[561,256],[561,257],[559,257],[558,258],[557,258],[557,256],[557,256],[558,254],[558,254],[559,254]],
      ],
      countryCenter: { x: 559.5, y: 255.5 },
      countryCode: 'RWA',
      countryId: 138,
      countryName: 'Rwanda',
    },
    139: {
      countryBorder: [
        [
          [315,198],
          { c: { x: 315, y: 198, label: { x: 314, y: 200, countryName: 'Nevis' } } }
        ],
        [
          [314.5,197.5],
          { c: { x: 314.5, y: 197.5, label: { x: 310, y: 198, countryName: 'St. Kitts' } } }
        ]
      ],
      countryCode: 'KNA',
      countryId: 139,
    },
    140: {
      countryCenter: { x: 318.5, y: 207.5 },
      countryCode: 'LCA',
      countryId: 140,
      countryName: 'St. Lucia',
      labelCenter: { x: 318.5, y: 206.5 }
    },
    141: {
      countryCenter: { x: 318, y: 209.5 },
      countryCode: 'VCT',
      countryId: 141,
      countryName: 'St. Vincent',
      labelCenter: { x: 312.3, y: 209.5 },
    },
    142: {
      countryCenter: { x:  26, y: 291.5 },
      countryCode: 'ASM',
      countryId: 142,
      countryName: 'American Samoa',
      labelCenter: { x:  31, y: 291.5 },
    },
    143: {
      countryCenter: { x: 497.5, y: 248.5 },
      countryCode: 'STP',
      countryId: 143,
      countryName: 'São tomé',
    },
    144: {
      countryBorder: [
        [[592,200],[592,199],[591,198],[591,197],[589,196],[588,193],[587,191],[585,189],[584,188],[582,185],[581,183],[581,181],[580,178],[578,177],[577,176],[576,175],[576,174],[575,172],[574,172],[573,169],[571,167],[570,165],[569,165],[569,163],[569,162],[569,161],[572,161],[573,161],[574,159],[575,159],[576,158],[577,158],[574,155],[579,153],[579,153],[582,153],[586,155],[594,162],[599,162],[601,162],[602,164],[604,163],[605,166],[607,167],[607,168],[609,169],[609,170],[609,171],[610,172],[610,173],[611,174],[611,175],[612,175],[613,175],[613,176],[614,177],[615,180],[623,182],[623,181],[625,183],[623,189],[616,192],[608,193],[606,195],[604,198],[603,198],[602,197],[601,198],[599,197],[598,197],[595,197],[595,197],[594,197],[593,198],[593,199]],
      ],
      countryCenter: { x: 597, y: 176.5 },
      countryCode: 'SAU',
      countryId: 144,
      countryName: 'Saudi Arabia',
    },
    145: {
      countryBorder: [
        [[435,209],[434,206],[433,205],[434,205],[436,202],[436,201],[437,200],[438,200],[440,200],[441,199],[442,200],[444,201],[446,203],[447,205],[448,207],[448,209],[449,210],[449,211],[449,212],[449,212],[447,212],[447,212],[446,212],[445,212],[443,212],[438,211],[438,212],[437,212],[435,212],[435,210],[437,210],[438,210],[439,210],[440,209],[441,209],[442,209],[443,209],[442,208],[442,208],[441,208],[440,208],[439,208],[438,208]],
      ],
      countryCenter: { x: 441, y: 205.5 },
      countryCode: 'SEN',
      countryId: 145,
      countryName: 'Senegal',
    },
    146: {
      countryBorder: [
        [[534,116],[533,117],[534,118],[535,119],[534,120],[534,121],[534,122],[534,122],[533,122],[532,122],[532,122],[532,122],[532,121],[532,121],[531,120],[531,120],[531,120],[530,120],[530,119],[529,119],[529,120],[529,121],[529,120],[528,120],[527,119],[527,119],[526,118],[526,118],[527,117],[525,116],[526,114],[525,114],[526,113],[525,113],[524,111],[526,111],[527,111],[529,112],[529,113],[531,114],[531,115],[533,116],[533,115],[534,115],[533,116]],
      ],
      countryCenter: { x: 529.5, y: 116.5 },
      countryCode: 'SRB',
      countryId: 146,
      countryName: 'Serbia',
    },
    147: {
      countryCenter: { x: 627, y: 263.5 },
      countryCode: 'SYC',
      countryId: 147,
      countryName: 'Seychelles',
    },
    148: {
      countryBorder: [
        [[449,229],[448,229],[447,228],[445,226],[445,225],[444,223],[446,221],[446,221],[447,220],[447,220],[448,219],[450,219],[451,220],[451,222],[451,222],[452,223],[452,224],[452,224],[451,226],[450,227],[450,228]],
      ],
      countryCenter: { x: 448, y: 224 },
      countryCode: 'SLE',
      countryId: 148,
      countryName: 'Sierra Leone',
    },
    149: {
      countryCenter: { x: 756, y: 245.5 },
      countryCode: 'SGP',
      countryId: 149,
      countryName: 'Singapore',
    },
    151: {
      countryBorder: [
        [[512,110],[514,110],[515,109],[517,109],[518,109],[518,109],[519,110],[517,110],[517,112],[516,112],[516,113],[515,113],[514,112],[514,113],[512,113],[513,112],[512,111]],
      ],
      countryCenter: { x: 515.5, y: 111 },
      countryCode: 'SVN',
      countryId: 151,
      countryName: 'Slovenia',
    },
    152: {
      countryBorder: [
        [[909,281],[910,282],[908,282],[907,280],[909,281]],
        [[906,279],[905,279],[903,279],[903,279],[903,277],[905,278],[906,279]],
        [[908,279],[908,279],[906,276],[906,275],[907,275],[908,277]],
        [[904,275],[904,275],[902,274],[901,273],[900,272],[900,272],[901,272],[903,274]],
        [[898,272],[898,272],[896,271],[895,270],[896,269],[897,271]]
      ],
      countryCenter: { x: 904.5, y: 276 },
      countryCode: 'SLB',
      countryId: 152,
      countryName: 'Solomon Is.',
    },
    153: {
      countryBorder: [
        [[606,225],[604,225],[595,222],[594,221],[593,219],[592,218],[593,217],[594,215],[595,216],[595,217],[596,218],[598,218],[600,217],[603,217],[605,216],[607,216],[608,215],[609,215],[609,215],[609,215],[610,215],[611,215],[613,214],[614,213],[615,213],[615,214],[615,216],[615,217],[614,219],[614,222],[613,225],[611,229],[609,233],[607,237],[604,241],[601,243],[597,246],[594,249],[592,252],[591,254],[590,255],[589,252],[589,241],[591,238],[592,237],[593,237],[596,235],[599,234]],
      ],
      countryCenter: { x: 602, y: 234 },
      countryCode: 'SOM',
      countryId: 153,
      countryName: 'Somalia',
    },
    154: {
      countryBorder: [
        [[522,336],[523,334],[524,335],[524,336],[525,337],[527,337],[528,337],[531,335],[531,324],[532,325],[533,328],[533,329],[533,330],[535,330],[537,329],[538,328],[539,326],[540,326],[541,326],[542,327],[544,327],[546,326],[546,325],[547,324],[548,324],[549,323],[550,321],[552,318],[556,316],[557,316],[559,317],[559,316],[561,317],[562,321],[562,323],[562,326],[562,327],[561,327],[560,327],[560,328],[559,329],[559,330],[560,332],[562,332],[562,330],[564,330],[563,332],[563,335],[562,336],[560,338],[560,338],[559,340],[558,341],[556,343],[553,347],[551,348],[549,350],[546,351],[545,351],[545,352],[543,351],[542,352],[539,351],[538,352],[536,352],[534,353],[532,353],[530,354],[529,355],[528,353],[527,353],[526,352],[526,352],[526,352],[526,350],[525,348],[526,347],[526,345],[524,342],[523,340],[523,340]],
      ],
      countryCenter: { x: 543, y: 335.5 },
      countryCode: 'ZAF',
      countryId: 154,
      countryName: 'S. Africa',
    },
    155: {
      countryBorder: [
        [[797,133],[801,137],[802,139],[804,142],[804,144],[802,144],[800,146],[798,146],[797,144],[796,142],[794,139],[796,138],[793,136],[793,135],[794,136],[794,134],[796,134],[797,134]]
      ],
      countryCenter: { x: 798.5, y: 139.5 },
      countryCode: 'KOR',
      countryId: 155,
      countryName: 'S. Korea',
    },
    157: {
      countryBorder: [
        [[458,123],[458,121],[457,120],[460,118],[463,118],[467,118],[469,119],[471,119],[475,119],[476,120],[480,121],[481,121],[484,122],[487,122],[487,123],[485,125],[482,126],[481,127],[480,129],[479,131],[480,133],[478,134],[478,136],[476,137],[474,139],[471,139],[469,139],[467,140],[466,141],[465,141],[464,140],[463,138],[461,138],[461,137],[462,136],[462,135],[461,134],[462,132],[461,130],[462,130],[462,128],[463,128],[463,126],[464,125],[463,123],[462,123],[461,124],[460,124],[460,122],[458,123]],
        [
          [443.5, 165.5],
          { c: { x: 443.5, y: 165.5, label: { x: 443.5, y: 164.7, countryName: 'Corralejo' } } }
        ],
        [
          [440.5, 167],
          { c: { x: 440.5, y: 167, label: { x: 440.5, y: 168, countryName: 'Gran Canaria' } } }
        ],
        [
          [436.5, 166],
          { c: { x: 436.5, y: 166, label: { x: 434, y: 166.2, countryName: 'Tenerife' } } }
        ],
        [
          [432.5, 164.5],
          { c: { x: 432.5, y: 164.5, label: { x: 432.5, y: 164.5, countryName: 'La Palma' } } }
        ],
      ],
      countryCenter: { x: 472, y: 127 },
      countryCode: 'ESP',
      countryId: 157,
      countryName: 'Spain',
    },
    158: {
      countryBorder: [
        [[697,227],[697,230],[695,231],[693,232],[692,229],[691,225],[692,220],[694,222],[695,224]]
      ],
      countryCenter: { x: 694, y: 226 },
      countryCode: 'LKA',
      countryId: 158,
      countryName: 'Sri Lanka',
    },
    159: {
      countryBorder: [
        [[570,221],[570,223],[569,224],[568,224],[567,226],[569,226],[570,228],[571,229],[572,230],[573,233],[572,235],[570,237],[568,238],[567,238],[564,239],[563,238],[562,239],[559,237],[559,236],[557,236],[556,236],[555,237],[554,236],[552,234],[552,233],[550,232],[549,230],[548,229],[546,227],[546,226],[545,225],[543,224],[543,224],[543,223],[542,223],[542,222],[542,220],[542,219],[540,217],[540,216],[540,215],[539,214],[539,213],[538,211],[538,212],[538,210],[538,209],[538,208],[539,207],[538,206],[539,204],[540,202],[542,202],[542,191],[542,189],[545,189],[545,183],[555,183],[565,183],[576,183],[577,186],[576,187],[577,190],[578,193],[579,194],[580,195],[579,197],[577,197],[576,198],[576,200],[575,205],[576,206],[575,209],[574,212],[573,213],[572,215],[572,217],[570,217],[570,221]]
      ],
      countryCenter: { x: 559, y: 203.5 },
      countryCode: 'SDN',
      countryId: 159,
      countryName: 'Sudan',
    },
    160: {
      countryBorder: [
        [[328,232],[331,232],[331,232],[333,231],[336,232],[335,235],[335,237],[336,239],[335,240],[335,241],[334,243],[333,242],[332,242],[330,242],[330,243],[331,243],[330,244],[329,244],[327,241],[327,239],[326,239],[325,237],[326,236],[325,235],[327,234]]
      ],
      countryCenter: { x: 330.5, y: 237.5 },
      countryCode: 'SUR',
      countryId: 160,
      countryName: 'Suriname',
    },
    161: {
      countryBorder: [
        [[503,74],[504,72],[506,71],[506,67],[505,66],[504,62],[505,60],[507,60],[508,59],[507,58],[510,54],[511,51],[512,49],[514,49],[515,48],[518,48],[518,47],[519,47],[522,48],[526,50],[527,54],[527,55],[524,55],[522,57],[523,59],[520,61],[517,63],[516,67],[517,69],[519,71],[518,74],[516,74],[516,79],[515,82],[512,82],[511,84],[508,84],[507,81],[505,78]]
      ],
      countryCenter: { x: 511.5, y: 63 },
      countryCode: 'SWE',
      countryId: 161,
      countryName: 'Sweden',
    },
    162: {
      countryBorder: [
        [[502,107],[502,107],[502,107],[502,108],[502,108],[502,108],[502,108],[502,108],[503,108],[503,108],[504,108],[504,110],[503,110],[501,110],[501,111],[500,111],[499,111],[498,112],[497,112],[496,111],[495,110],[494,110],[494,109],[495,107],[495,107],[496,107],[497,106],[499,106],[500,106]]
      ],
      countryCenter: { x: 499, y: 109 },
      countryCode: 'CHE',
      countryId: 162,
      countryName: 'Switzerland',
      labelCenter: { x: 497, y: 110 },
    },
    163: {
      countryBorder: [
        [[578,149],[573,152],[570,151],[570,151],[570,150],[570,149],[571,148],[572,146],[571,145],[570,145],[570,143],[570,142],[571,141],[571,140],[571,139],[572,139],[575,138],[576,139],[578,139],[581,138],[582,138],[585,137],[584,139],[583,140],[583,142],[583,146]]
      ],
      countryCenter: { x: 577.5, y: 144.5 },
      countryCode: 'SYR',
      countryId: 163,
      countryName: 'Syria',
    },
    164: {
      countryBorder: [
        [[796,176],[795,181],[794,183],[792,181],[792,179],[793,176],[794,173],[796,174]]
      ],
      countryCenter: { x: 794, y: 178 },
      countryCode: '---',
      countryId: 164,
      countryName: 'Taiwan',
    },
    165: {
      countryBorder: [
        [[654,128],[653,129],[650,129],[650,130],[653,130],[656,131],[661,131],[662,133],[663,133],[665,134],[665,135],[666,137],[663,137],[662,136],[660,138],[659,138],[659,139],[657,138],[657,135],[656,135],[656,134],[655,134],[654,135],[654,136],[654,136],[652,136],[652,138],[651,137],[649,138],[648,138],[649,135],[648,132],[646,132],[646,130],[648,130],[649,129],[649,127],[652,126],[652,127],[653,128]]
      ],
      countryCenter: { x: 656, y: 132.5 },
      countryCode: 'TJK',
      countryId: 165,
      countryName: 'Tajikistan',
    },
    166: {
      countryBorder: [
        [[570,252],[570,253],[580,259],[580,261],[584,264],[583,267],[583,269],[584,270],[584,271],[584,273],[584,274],[584,275],[584,277],[585,280],[586,281],[584,282],[581,284],[580,284],[579,284],[577,285],[576,285],[573,284],[571,284],[570,280],[570,279],[569,278],[566,277],[565,276],[563,276],[562,275],[561,275],[560,271],[558,269],[558,267],[558,266],[558,263],[559,263],[560,262],[561,260],[561,260],[561,259],[561,258],[561,257],[561,256],[562,255],[561,253],[562,253],[564,253]]
      ],
      countryCenter: { x: 572, y: 268.5 },
      countryCode: 'TZA',
      countryId: 166,
      countryName: 'Tanzania',
    },
    167: {
      countryBorder: [
        [[751,213],[748,211],[746,211],[746,209],[744,209],[744,212],[743,217],[742,220],[743,222],[745,222],[746,225],[746,227],[748,229],[750,229],[751,231],[750,232],[749,232],[748,231],[746,230],[746,230],[744,229],[744,227],[742,226],[741,224],[741,226],[740,224],[740,222],[741,220],[742,216],[743,214],[742,211],[742,210],[741,208],[739,205],[738,204],[739,203],[740,201],[739,199],[737,197],[735,194],[736,193],[737,190],[739,190],[740,189],[741,188],[743,189],[743,191],[745,191],[745,194],[745,197],[748,195],[748,195],[750,195],[750,194],[752,195],[755,197],[755,200],[758,203],[758,205],[757,207],[755,206],[751,207],[750,209]]
      ],
      countryCenter: { x: 746.5, y: 210 },
      countryCode: 'THA',
      countryId: 167,
      countryName: 'Thailand',
      labelCenter: { x: 746.5, y: 205 },
    },
    168: {
      countryBorder: [
        [[485,231],[482,232],[482,231],[481,229],[481,227],[481,224],[481,223],[481,221],[481,219],[479,217],[480,216],[482,216],[482,218],[482,219],[483,220],[483,221],[484,222],[484,229]]
      ],
      countryCenter: { x: 482, y: 224 },
      countryCode: 'TGO',
      countryId: 168,
      countryName: 'Togo',
    },
    169: {
      countryBorder: [
        [
          [83,314],
          { c: { x: 83, y: 314 } }
        ],
        [
          [82,313.5],
          { c: { x: 82, y: 313.5 } }
        ],
        [
          [83,306],
          { c: { x: 83, y: 306 } }
        ]
      ],
      countryCode: 'PYF',
      countryId: 169,
      countryName: 'French Polynesia',
      labelCenter: { x: 82.5, y: 310 },
    },
    170: {
      countryBorder: [
        [[316,217],[318,217],[318,217],[318,219],[316,219],[315,219],[316,218]],
      ],
      countryCenter: { x: 316.5, y: 218 },
      countryCode: 'TTO',
      countryId: 170,
      countryName: 'Trinidad & Tobago',
      labelCenter: { x: 323.5, y: 218 },
    },
    171: {
      countryBorder: [
        [[504,158],[503,153],[501,152],[501,151],[499,149],[499,147],[500,145],[501,143],[500,140],[501,138],[503,137],[505,137],[505,139],[507,138],[507,138],[506,140],[506,141],[507,142],[507,145],[505,146],[506,148],[507,148],[508,149],[509,150],[509,152],[507,153],[507,154],[505,155],[505,156],[505,157]]
      ],
      countryCenter: { x: 504, y: 147.5 },
      countryCode: 'TUN',
      countryId: 171,
      countryName: 'Tunisia',
    },
    172: {
      countryBorder: [
        [[581,124],[583,124],[586,126],[587,127],[587,128],[589,129],[590,130],[588,131],[590,134],[589,135],[591,137],[590,138],[589,137],[586,137],[585,137],[582,138],[581,138],[578,139],[576,139],[575,138],[572,139],[571,139],[571,140],[571,141],[570,142],[569,140],[570,139],[568,139],[566,139],[565,140],[561,141],[559,139],[556,139],[555,140],[554,141],[551,139],[548,139],[547,136],[545,134],[546,132],[544,131],[546,128],[550,128],[551,125],[556,126],[558,124],[561,123],[565,123],[570,125],[573,126],[576,126],[578,126]],
        [[543,127],[544,126],[544,124],[543,124],[545,123],[548,123],[548,124],[550,125],[550,126],[547,126],[546,127],[544,129],[543,127]],
      ],
      countryCenter: { x: 567.5, y: 132.5 },
      countryCode: 'TUR',
      countryId: 172,
      countryName: 'Turkey',
    },
    173: {
      countryBorder: [
        [[633,142],[632,140],[630,139],[627,137],[625,136],[622,135],[620,135],[619,135],[617,135],[616,137],[614,137],[613,135],[613,132],[610,131],[611,129],[609,129],[609,126],[611,127],[613,126],[611,124],[610,123],[608,123],[608,126],[607,124],[608,123],[611,122],[613,123],[615,125],[616,125],[619,125],[618,124],[620,122],[621,121],[625,122],[626,125],[627,125],[630,125],[631,126],[633,129],[636,131],[638,132],[641,134],[645,135],[645,137],[644,137],[643,136],[643,137],[641,138],[641,140],[640,141],[638,141],[637,143],[636,143]]
      ],
      countryCenter: { x: 626, y: 132 },
      countryCode: 'TKM',
      countryId: 173,
      countryName: 'Turkmenistan',
    },
    174: {
      countryBorder: [
        [
          [953,273.5],
          { c: { x: 953, y: 273.5 } }
        ],
        [
          [954,272],
          { c: { x: 954, y: 272 } }
        ],
        [
          [955,275.5],
          { c: { x: 955, y: 275.5 } }
        ],
        [
          [957,278],
          { c: { x: 957, y: 278 } }
        ],
        [
          [948,287],
          { c: { x: 948, y: 287 } }
        ],
        [
          [950,271],
          { c: { x: 950, y: 271 } }
        ],
        [
          [948,267],
          { c: { x: 948, y: 267 } }
        ]
      ],
      countryCode: 'TUV',
      countryId: 174,
      countryName: 'Tuvalu',
      labelCenter: { x: 953, y: 273.5 }
    },
    175: {
      countryBorder: [
        [[561,253],[559,254],[558,254],[558,251],[559,250],[559,248],[560,246],[561,245],[562,244],[563,243],[562,242],[562,239],[563,238],[564,239],[567,238],[568,238],[570,237],[571,239],[572,240],[573,244],[572,246],[571,248],[570,249],[570,252],[564,253],[562,253]],
      ],
      countryCenter: { x: 565.5, y: 245.5 },
      countryCode: 'UGA',
      countryId: 175,
      countryName: 'Uganda',
    },
    176: {
      countryBorder: [
        [[552,93],[553,93],[553,93],[554,93],[556,93],[558,94],[558,95],[558,96],[560,96],[561,97],[561,98],[564,99],[566,98],[567,100],[569,100],[572,101],[573,101],[572,103],[573,105],[573,106],[570,106],[569,107],[570,108],[568,108],[566,109],[564,109],[562,110],[563,112],[564,113],[567,113],[566,114],[564,114],[561,116],[559,115],[560,114],[557,113],[557,113],[559,112],[559,111],[555,110],[554,109],[552,109],[552,111],[550,113],[549,113],[548,113],[547,113],[547,112],[548,111],[548,110],[548,110],[548,110],[549,110],[550,110],[551,110],[550,110],[550,109],[549,108],[549,107],[548,107],[548,106],[547,105],[546,105],[544,104],[542,104],[542,105],[541,105],[540,105],[539,106],[538,106],[537,105],[535,105],[534,105],[533,106],[533,105],[531,104],[531,103],[532,102],[533,102],[532,101],[534,98],[535,98],[535,97],[533,95],[534,95],[536,94],[537,94],[540,94],[542,95],[544,95],[545,95],[546,95],[547,95],[549,95],[550,96],[549,94],[550,93]],
      ],
      countryCenter: { x: 552, y: 101 },
      countryCode: 'UKR',
      countryId: 176,
      countryName: 'Ukraine',
    },
    177: {
      countryBorder: [[[613,176],[614,176],[614,177],[616,177],[618,177],[620,177],[621,175],[623,173],[625,171],[625,172],[626,174],[624,174],[624,176],[625,177],[624,177],[624,179],[623,180],[623,181],[623,182],[615,180],[614,177]],],
      countryCenter: { x: 619.5, y: 176.5 },
      countryCode: 'ARE',
      countryId: 177,
      countryName: 'UAE',
    },
    178: {
      countryBorder: [
        [[466,88],[464,88],[463,88],[463,86],[463,85],[465,84],[467,86]],
        [[473,75],[471,78],[473,77],[475,77],[475,80],[473,82],[475,82],[475,83],[477,86],[479,86],[480,90],[481,91],[483,91],[483,93],[482,94],[483,96],[481,97],[478,97],[474,98],[473,97],[471,99],[469,98],[467,99],[466,99],[470,96],[472,95],[472,95],[468,95],[468,94],[470,93],[469,91],[469,89],[473,89],[473,89],[473,88],[471,86],[471,86],[469,86],[468,85],[469,83],[468,83],[467,84],[467,81],[466,80],[467,77],[469,75],[470,75]],
        [
          [474,73.5],
          { c: { x: 474, y: 73.5, label: { x: 474, y: 73.5, countryName: 'Orkney' } } }
        ],
        [
          [475.5,69],
          { c: { x: 475.5, y: 69, label: { x: 475.5, y: 69, countryName: 'Shetland' } } }
        ],
        [
          [335,403],[336,402],[338,402],[339,403],[338,404],[336,404],[335,403],
          { c: { x: 337, y: 403, label: { x: 337, y: 403, countryName: 'The Falklands' } } }
        ],
        [
          [387.5,415.5],
          { c: { x: 387.5, y: 415.5, label: { x: 387.5, y: 415.5, countryName: 'South Georgia' } } }
        ],
        [
          [464.5,298.5],
          { c: { x: 464.5, y: 298.5, label: { x: 464.5, y: 298.5, countryName: 'St H., Asc. & T\'d Cunha' } } }
        ],
        [
          [140.5,320.5],
          { c: { x: 140.5, y: 320.5, label: { x: 140.5, y: 320.5, countryName: 'Pitcairn Is' } } }
        ]
      ],
      countryCenter: { x: 474.5, y: 87 },
      countryCode: 'GBR',
      countryId: 178,
      countryName: 'UK',
      labelCenter: { x: 475.5, y: 92 },
    },
    179: {
      countryBorder: [
        [
          [72,192],[71,193],[71,192],[71,191],[71,190],[71,190],[72,189],[72,189],[72,188],[72,188],[73,189],[73,189],[74,190],[74,191],[74,191],[73,192],
          { c: { x: 68.5, y: 189.5, label: { x: 68.5, y: 188, countryName: 'Hawaii' } } }
        ],
        [[72,187],[71,188],[70,187],[70,187],[70,186],[71,186],[71,186],[72,187]],
        [[64,183],[64,184],[63,183],[63,183],[64,182],[64,183]],
        [[319,114],[319,115],[316,116],[314,117],[311,118],[309,120],[308,120],[308,122],[308,124],[309,124],[309,123],[310,123],[309,124],[307,125],[306,125],[304,125],[303,125],[302,125],[299,126],[303,126],[304,126],[300,127],[299,127],[299,127],[298,128],[298,128],[297,130],[295,132],[295,131],[294,131],[294,130],[294,132],[294,133],[294,134],[293,135],[291,137],[290,137],[292,135],[291,134],[291,132],[290,133],[290,135],[289,134],[290,135],[290,138],[290,138],[290,139],[290,142],[288,145],[285,145],[283,147],[281,147],[280,149],[279,150],[276,152],[274,153],[273,155],[272,157],[272,159],[272,162],[273,164],[272,165],[273,168],[273,171],[272,172],[271,174],[270,174],[269,174],[269,172],[268,172],[267,169],[267,167],[266,165],[267,163],[267,162],[265,159],[265,159],[262,160],[261,160],[260,159],[259,158],[256,158],[254,158],[252,158],[251,159],[251,159],[250,161],[251,161],[250,162],[249,161],[248,162],[247,162],[245,160],[243,160],[241,160],[239,160],[237,161],[234,163],[231,164],[230,166],[229,167],[228,169],[228,171],[228,172],[227,172],[226,171],[224,170],[223,169],[223,166],[222,165],[222,163],[221,161],[219,160],[217,160],[215,162],[213,161],[212,160],[212,159],[211,157],[210,156],[209,155],[209,154],[204,154],[204,155],[202,155],[197,155],[192,153],[188,151],[189,151],[186,151],[183,151],[183,150],[182,148],[181,148],[181,147],[179,147],[179,146],[177,146],[176,145],[177,144],[175,141],[175,136],[176,136],[175,135],[174,132],[175,130],[175,128],[176,126],[178,123],[178,121],[181,118],[183,115],[185,113],[187,109],[188,106],[188,105],[188,104],[191,105],[191,108],[192,107],[193,105],[194,102],[200,102],[207,102],[209,102],[217,102],[223,102],[230,102],[237,102],[245,102],[253,102],[258,102],[259,101],[259,101],[259,103],[259,103],[261,103],[263,104],[265,105],[267,104],[270,105],[270,105],[273,104],[275,105],[276,107],[278,108],[279,108],[279,109],[280,110],[279,110],[280,110],[281,110],[280,110],[281,111],[281,111],[281,111],[281,112],[283,113],[282,116],[282,118],[280,120],[279,122],[278,123],[278,123],[278,123],[278,124],[279,124],[282,122],[285,122],[289,120],[289,120],[289,119],[289,119],[290,118],[292,118],[295,118],[296,117],[296,117],[300,115],[301,114],[304,114],[309,114],[309,113],[310,113],[311,113],[313,111],[314,109],[317,107],[317,108],[319,107],[320,108],[318,112]],
        [[145,79],[142,80],[142,79],[143,78],[146,77],[147,77],[149,77],[149,78]],
        [[127,71],[125,72],[124,71],[124,70],[127,70],[128,70]],
        [[128,61],[128,61],[130,61],[131,62],[132,62],[132,62],[129,63],[128,62],[128,62],[126,62],[126,62]],
        [[184,72],[184,74],[188,72],[191,71],[190,73],[191,74],[192,75],[191,77],[190,81],[193,82],[191,84],[189,85],[188,84],[187,84],[189,81],[188,79],[189,76],[187,76],[184,76],[182,75],[181,72],[179,72],[176,71],[173,71],[170,70],[169,68],[166,69],[165,71],[163,71],[160,72],[157,73],[154,73],[156,72],[160,69],[163,68],[163,67],[159,69],[155,71],[150,73],[150,74],[146,76],[142,77],[139,78],[137,79],[132,81],[130,82],[126,83],[125,83],[122,84],[119,85],[116,86],[111,87],[111,86],[115,85],[118,84],[122,82],[125,82],[128,81],[133,79],[134,79],[136,78],[139,76],[142,74],[139,75],[138,74],[136,75],[136,74],[135,75],[135,73],[132,75],[131,75],[132,73],[134,72],[134,71],[130,71],[130,70],[129,69],[131,68],[131,67],[134,65],[138,64],[140,62],[142,62],[143,63],[146,61],[147,61],[150,61],[151,59],[151,59],[153,58],[152,58],[149,59],[148,59],[147,59],[144,59],[142,58],[142,57],[142,56],[146,54],[152,53],[154,53],[152,55],[156,54],[157,53],[156,52],[156,51],[156,49],[154,49],[157,47],[161,47],[165,46],[167,45],[171,44],[173,43],[178,42],[180,42],[185,41],[187,42],[187,43],[188,42],[191,42],[190,43],[192,43],[195,43],[198,44],[201,44],[202,44],[205,44],[207,45],[209,45],[209,45],[197,55],[180,70],[182,70],[184,71]]
      ],
      countryCenter: { x: 247, y: 137.5 },
      countryCode: 'USA',
      countryId: 179,
      countryName: 'USA',
    },
    180: {
      countryBorder: [
        [[332,341],[334,340],[337,343],[338,343],[341,345],[343,346],[345,348],[344,350],[345,351],[344,353],[342,355],[340,354],[338,355],[336,353],[334,353],[332,352],[332,350],[332,349],[332,346],[332,343]],
      ],
      countryCenter: { x: 338.5, y: 349 },
      countryCode: 'URY',
      countryId: 180,
      countryName: 'Uruguay',
    },
    181: {
      countryBorder: [
        [[645,137],[645,135],[641,134],[638,132],[636,131],[633,129],[631,126],[630,125],[627,125],[626,125],[625,122],[621,121],[620,122],[618,124],[619,125],[616,125],[613,114],[619,112],[619,113],[624,115],[626,116],[629,119],[632,118],[636,118],[639,120],[640,123],[641,123],[642,125],[645,126],[647,127],[647,127],[648,125],[650,123],[652,122],[653,122],[651,124],[653,126],[655,125],[658,126],[656,129],[654,128],[653,128],[652,127],[652,126],[649,127],[649,129],[648,130],[646,130],[646,132],[648,132],[649,135],[648,138],[646,137]],
      ],
      countryCenter: { x: 635.5, y: 125 },
      countryCode: 'UZB',
      countryId: 181,
      countryName: 'Uzbekistan',
      labelCenter: { x: 631, y: 121 },
    },
    182: {
      countryBorder: [
        [[921,299],[920,300],[920,298],[920,297]],
        [[920,295],[920,297],[920,297],[919,297],[919,296],[919,294]],
      ],
      countryCenter: { x: 920, y: 297 },
      countryCode: 'VUT',
      countryId: 182,
      countryName: 'Vanuatu',
    },
    183: {
      countryBorder: [
        [[291,214],[291,215],[289,215],[290,216],[290,218],[288,220],[289,222],[290,222],[291,220],[290,219],[290,216],[294,215],[293,214],[294,213],[295,215],[297,215],[299,217],[299,218],[301,218],[304,217],[305,219],[307,219],[309,218],[309,217],[312,217],[316,217],[313,218],[314,220],[316,220],[318,221],[318,224],[320,224],[321,224],[319,226],[318,227],[319,228],[319,229],[317,229],[317,231],[316,232],[318,234],[318,235],[317,236],[314,237],[312,237],[312,238],[310,237],[308,237],[307,237],[308,238],[308,240],[308,242],[311,242],[311,243],[309,244],[309,245],[307,246],[305,246],[305,247],[303,247],[301,246],[301,243],[300,242],[299,241],[300,240],[300,239],[300,238],[299,236],[299,234],[300,233],[301,231],[300,231],[298,231],[296,231],[295,231],[293,229],[292,228],[288,228],[288,227],[287,227],[287,227],[287,225],[287,224],[287,224],[286,222],[285,222],[286,220],[286,218],[287,217],[288,216],[289,215]],
      ],
      countryCenter: { x: 303, y: 225 },
      countryCode: 'VEN',
      countryId: 183,
      countryName: 'Venuzuela',
    },
    184: {
      countryBorder: [
        [[761,185],[758,187],[757,190],[756,192],[759,195],[762,199],[765,201],[767,203],[768,209],[769,214],[767,216],[764,218],[762,221],[759,224],[758,222],[758,220],[756,218],[758,217],[761,216],[760,215],[764,212],[764,209],[763,207],[763,204],[762,202],[760,199],[758,197],[755,193],[752,191],[752,190],[754,190],[752,187],[749,187],[748,184],[746,182],[747,181],[749,181],[752,181],[753,179],[755,180],[757,181],[757,183],[759,184]]
      ],
      countryCenter: { x: 757.5, y: 201.5 },
      countryCode: 'VNM',
      countryId: 184,
      countryName: 'Vietnam',
      labelCenter: { x: 756, y: 185 },
    },
    185: {
      countryBorder: [
        [[446,166],[457,166],[457,166],[457,167],[457,172],[449,171],[449,179],[446,179],[445,181],[446,185],[436,185],[435,186],[435,185],[435,184],[436,183],[437,181],[437,180],[438,178],[440,176],[440,176],[441,174],[441,172],[442,170],[444,169],[445,168],[445,167]],
      ],
      countryCenter: { x: 446, y: 176 },
      countryCode: '---',
      countryId: 185,
      countryName: 'Western Sahara',
    },
    186: {
      countryBorder: [
        [[619,199],[617,200],[617,201],[617,203],[614,204],[610,205],[608,207],[607,207],[606,207],[605,209],[603,209],[601,209],[600,209],[600,210],[599,210],[599,211],[597,211],[596,212],[595,211],[594,210],[594,208],[593,207],[593,205],[592,204],[592,204],[592,202],[592,202],[592,200],[593,199],[593,198],[594,197],[595,197],[595,197],[598,197],[599,197],[601,198],[602,197],[603,198],[604,198],[606,195],[608,193],[616,192],[618,197]],
      ],
      countryCenter: { x: 605.5, y: 202 },
      countryCode: 'YEM',
      countryId: 186,
      countryName: 'Yemen',
    },
    187: {
      countryBorder: [
        [[566,277],[568,279],[568,281],[568,282],[567,285],[568,287],[567,288],[566,291],[567,292],[559,294],[559,296],[557,297],[556,298],[555,299],[554,299],[552,302],[551,304],[550,304],[549,303],[546,303],[545,303],[545,303],[544,302],[543,302],[541,302],[539,301],[537,298],[538,288],[543,288],[543,287],[543,286],[543,285],[543,283],[543,283],[544,283],[544,284],[545,283],[547,284],[548,285],[550,286],[551,285],[552,286],[554,287],[555,288],[556,290],[558,290],[558,286],[557,287],[555,286],[555,285],[555,282],[556,279],[555,277],[556,275],[557,275],[560,274],[561,275],[562,275],[563,276],[565,276]],
      ],
      countryCenter: { x: 547, y: 294 },
      countryCode: 'ZMB',
      countryId: 187,
      countryName: 'Zambia',
    },
    188: {
      countryBorder: [
        [[561,317],[559,316],[559,317],[557,316],[556,316],[555,315],[553,314],[552,312],[552,311],[551,311],[548,308],[547,306],[547,305],[546,303],[549,303],[550,304],[551,304],[552,302],[554,299],[555,299],[556,298],[557,297],[559,296],[559,297],[562,297],[563,298],[563,299],[565,299],[566,300],[566,304],[565,306],[565,308],[565,309],[565,311],[565,311],[564,313]],
      ],
      countryCenter: { x: 556, y: 306.5 },
      countryCode: 'ZWE',
      countryId: 188,
      countryName: 'Zimbabwe',
    },
    189: {
      countryBorder: [
        [[531,126],[531,127],[530,128],[530,129],[529,130],[529,130],[529,129],[527,128],[527,127],[527,125],[527,124],[527,123],[526,122],[527,121],[528,122],[528,121],[529,122],[529,122],[530,123],[529,124],[530,126]]
      ],
      countryCenter: { x: 528.5, y: 127 },
      countryCode: 'ALB',
      countryId: 189,
      countryName: 'Albania',
    },
    190: {
      countryCenter: { x: 483.5, y: 121.5 },
      countryCode: 'AND',
      countryId: 190,
      countryName: 'Andorra',
    },
    191: {
      countryBorder: [
        [[721,183],[721,185],[720,185],[721,187],[720,186],[720,184],[719,183],[718,181],[715,181],[716,182],[715,184],[714,183],[713,184],[713,183],[712,183],[711,181],[710,178],[710,176],[708,176],[708,175],[710,173],[708,172],[708,170],[711,171],[712,171],[712,173],[715,174],[717,174],[719,174],[718,177],[717,177],[717,179],[718,180],[718,178],[719,178]]
      ],
      countryCenter: { x: 714.5, y: 178.5 },
      countryCode: 'BGD',
      countryId: 191,
      countryName: 'Bangladesh',
      labelCenter: { x: 714.5, y: 176 },
    },
    192: {
      countryBorder: [
        [[489,96],[491,95],[492,96],[494,97],[494,99],[493,99],[493,101],[491,99],[489,100],[488,98],[487,97],[486,97],[485,96],[487,95]]
      ],
      countryCenter: { x: 489.5, y: 98},
      countryCode: 'BEL',
      countryId: 192,
      countryName: 'Belgium',
    },
    193: {
      countryBorder: [
        [[593,211],[594,212],[594,213],[593,214],[594,215],[593,217],[592,216],[592,216],[590,216],[590,215],[590,214],[591,213],[592,212],[593,212]]
      ],
      countryCenter: { x: 592, y: 214 },
      countryCode: 'DJI',
      countryId: 193,
      countryName: 'Djibouti',
    },
    194: {
      countryBorder: [
        [[502,108],[502,108],[502,108],[502,108],[502,108],[502,108],[502,108],[502,108],[502,108],[502,107]]
      ],
      countryCenter: { x: 502, y: 107.5 },
      countryCode: 'LIE',
      countryId: 194,
      countryName: 'Liechenstein',
    },
    195: {
      countryBorder: [
        [[554,337],[555,338],[554,339],[553,340],[552,341],[551,342],[550,342],[549,340],[550,338],[552,337],[553,336]]
      ],
      countryCenter: { x: 552, y: 339 },
      countryCode: 'LSO',
      countryId: 195,
      countryName: 'Lesotho',
    },
    196: {
      countryCenter: { x: 497, y: 118.5 },
      countryCode: 'MCO',
      countryId: 196,
      countryName: 'Monaco',
    },
    197: {
      countryBorder: [[
        [535,47],[535,45],[533,44],[530,45],[529,47],[528,48],[525,47],[523,47],[521,46],[519,47],[518,47],[518,48],[515,48],[514,49],[512,49],[511,51],[510,54],[507,58],[508,59],[507,60],[505,60],[504,62],[505,66],[506,67],[506,71],[504,72],[503,74],[502,72],[498,76],[495,76],[492,75],[491,72],[490,65],[492,64],[497,61],[501,59],[504,55],[509,50],[512,48],[516,45],[520,44],[524,44],[526,42],[529,42],[533,41],[539,43],[537,44],[539,46],[536,47]],
        [[522,26],[518,27],[515,26],[516,26],[515,25],[518,24],[519,25]],
        [[510,22],[516,23],[512,24],[511,26],[510,26],[509,28],[507,28],[503,27],[505,26],[502,25],[498,24],[497,22],[501,21],[502,22],[505,22],[505,21],[508,21]],
        [[521,20],[525,21],[523,22],[518,22],[513,22],[513,21],[510,21],[508,20],[513,20],[516,20],[517,20]]
      ],
      countryCenter: { x: 498, y: 67 },
      countryCode: 'NOR',
      countryId: 197,
      countryName: 'Norway',
    },
    198: {
      countryBorder: [
        [[619,199],[618,197],[616,192],[623,189],[625,183],[623,181],[623,180],[624,179],[624,177],[625,177],[624,176],[624,174],[626,174],[627,176],[629,178],[631,178],[632,178],[634,180],[634,181],[635,182],[635,182],[635,184],[634,185],[633,186],[632,188],[631,188],[631,189],[631,190],[631,192],[631,192],[630,192],[628,194],[628,195],[627,196],[626,196],[625,196],[625,198],[624,198],[622,198],[620,199]],
        [[625,172],[625,171],[625,170],[626,170],[625,171]]
      ],
      countryCenter: { x: 629.5, y: 183.5 },
      countryCode: 'OMN',
      countryId: 198,
      countryName: 'Oman',
    },
    199: {
      countryCenter: { x: 509.5, y: 117 },
      countryCode: 'SMR',
      countryId: 199,
      countryName: 'San Marino',
    },
    200: {
      countryBorder: [
        [[610,172],[610,172],[610,172],[610,171],[610,171],[610,171],[610,170],[610,170],[610,171],[610,171]]
      ],
      countryCenter: { x: 610, y: 171 },
      countryCode: 'BHR',
      countryId: 200,
      countryName: 'Bahrain',
    },
    201: {
      countryBorder: [
        [[602,159],[603,160],[603,161],[604,163],[602,164],[601,162],[599,162],[600,159]]
      ],
      countryCenter: { x: 601.5, y: 161.5 },
      countryCode: 'KWT',
      countryId: 201,
      countryName: 'Kuwait',
    },
    202: {
      countryBorder: [
        [[611,175],[611,173],[611,171],[612,171],[613,172],[613,174],[613,175],[612,175]]
      ],
      countryCenter: { x: 612, y: 173 },
      countryCode: 'QAT',
      countryId: 202,
      countryName: 'Qatar',
    },
    203: {
      countryCenter: { x: 294.4, y: 210.5 },
      countryCode: 'ABW',
      countryId: 203,
      countryName: 'Aruba',
    },
    204: {
      countryCenter: { x: 24, y: 290.5 },
      countryCode: 'WSM',
      countryId: 204,
      countryName: 'Samoa',
      labelCenter: { x:  18, y: 290.5 },
    },
    205: {
      countryCenter: { x: 310.5, y: 154.5 },
      countryCode: 'BMU',
      countryId: 205,
      countryName: 'Bermuda',
    },
    206: {
      countryBorder: [
        [
          [473.5,101.5],
          { c: { x: 473.5, y: 101.5 } }
        ],
        [
          [473,101],
          { c: { x: 473, y: 101 } }
        ]
      ],
      countryCode: 'CHI',
      countryId: 206,
      countryName: 'Channel Is.',
      labelCenter: { x: 468, y: 101 },
    },
    207: {
      countryCenter: { x: 297.7, y: 212.7 },
      countryCode: 'CUW',
      countryId: 207,
      countryName: 'Curacao',
    },
    208: {
      countryCenter: { x: 270, y: 192 },
      countryCode: 'CYM',
      countryId: 208,
      countryName: 'Cayman Is.',
    },
    209: {
      countryBorder: [
        [
          [930.5,231.5],
          { c: { x: 930.5, y: 231.5 } },
        ],
        [
          [929.5,227.5],
          { c: { x: 929.5, y: 227.5 } },
        ],
        [
          [928.5,223.5],
          { c: { x: 928.5, y: 223.5 } },
        ],
        [
          [927.5,220.5],
          { c: { x: 927.5, y: 220.5 } },
        ],
        [
          [928,232.5],
          { c: { x: 928, y: 232.5 } },
        ],
        [
          [927,230],
          { c: { x: 927, y: 230 } },
        ],
        [
          [924.5,225],
          { c: { x: 924.5, y: 225 } },
        ],
        [
          [922.5,222.5],
          { c: { x: 922.5, y: 222.5 } },
        ],
      ],
      labelCenter: { x: 927, y: 227 },
      countryCode: 'MHL',
      countryId: 209,
      countryName: 'Marshall Is.',
    },
    210: {
      countryCenter: { x:  12, y: 312 },
      countryCode: 'TON',
      countryId: 210,
      countryName: 'Tonga',
    },
    211: {
      countryCenter: { x: 463.5, y: 66.5 },
      countryCode: 'FRO',
      countryId: 211,
      countryName: 'Faroe Is.',
    },
    212: {
      countryCenter: { x: 465.7, y: 141.5 },
      countryCode: 'GIB',
      countryId: 212,
      countryName: 'Gibraltra',
    },
    213: {
      countryCenter: { x: 777, y: 183 },
      countryCode: 'HKG',
      countryId: 213,
      countryName: 'Hong Kong',
      labelCenter: { x: 782.5, y: 182 },
    },
    214: {
      countryCenter: { x: 468.5, y: 87.5 },
      countryCode: 'IMN',
      countryId: 214,
      countryName: 'Isle of Man',
      labelCenter: { x: 465.5, y: 87.5 },
    },
    215: {
      countryCenter: { x: 774, y: 183.5 },
      countryCode: 'MAC',
      countryId: 215,
      countryName: 'Macao',
      labelCenter: { x: 771.5, y: 184 },
    },
    216: {
      countryCenter: { x: 314, y: 193 },
      countryCode: 'SXM',
      countryId: 216,
      countryName: 'Sint. Marteen',
      labelCenter: { x: 323, y: 192 },
    },
    217: {
      countryCenter: { x: 858.5, y: 215.5 },
      countryCode: 'MNP',
      countryId: 217,
      countryName: 'Northern Mariana Is.',
    },
    218: {
      countryCenter: { x: 291.5, y: 185 },
      countryCode: 'TCA',
      countryId: 218,
      countryName: 'Turks & Caicos Is.',
    },
    219: {
      countryCenter: { x: 311, y: 191 },
      countryCode: 'VGB',
      countryId: 219,
      countryName: 'UK V Is',
      labelCenter: { x: 309, y: 190 },
    },
    220: {
      countryCenter: { x: 310.5, y: 194 },
      countryCode: 'VIR',
      countryId: 220,
      countryName: 'US V Is',
      labelCenter: { x: 306, y: 193 },
    },
    221: {
      countryCenter: { x:  52.5, y: 315.5 },
      countryCode: '---',
      countryId: 221,
      countryName: 'Cook Is',
    },
    222: {
      countryCenter: { x: 26.5, y: 275.5 },
      countryCode: '---',
      countryId: 222,
      countryName: 'Tokelau',
    },
    223: {
      countryCenter: { x: 28.5, y: 305.5 },
      countryCode: '---',
      countryId: 223,
      countryName: 'Niue',
    },
  },
  1992: {
    43: {
      countryBorder: [
        [[519,103],[518,103],[517,103],[515,102],[514,102],[513,104],[511,103],[510,101],[509,101],[508,99],[508,99],[509,98],[510,97],[512,97],[512,96],[513,96],[514,96],[515,97],[517,97],[517,98],[518,99],[518,98],[520,98],[520,99],[522,99],[523,101],[522,101],[522,102],[521,102],[521,103],[520,103],[519,103]]
      ],
      countryCenter: { x: 515.5, y: 99.5 },
      countryCode: 'CZE',
      countryId: 43,
      countryName: 'Czech Rep.',
      labelCenter: { x: 515.5, y: 99.5 },
    },
    150: {
      countryBorder: [
        [[523,101],[523,101],[524,101],[526,102],[527,101],[528,101],[530,101],[532,102],[531,103],[531,104],[531,104],[528,103],[527,104],[527,104],[526,105],[526,104],[524,105],[524,105],[523,106],[521,106],[521,106],[519,105],[519,104],[519,103],[519,103],[520,103],[521,103],[521,102],[522,102],[522,101],[522,101],[523,101]],
      ],
      countryCenter: { x: 525.5, y: 103.5 },
      countryCode: 'SVK',
      countryId: 150,
      countryName: 'Slovakia',
    },
  },
  2011: {
    156: {
      countryBorder: [
        [[570,221],[570,223],[569,224],[568,224],[567,226],[569,226],[570,228],[571,229],[572,230],[573,233],[572,235],[570,237],[568,238],[567,238],[564,239],[563,238],[562,239],[559,237],[559,236],[557,236],[556,236],[555,237],[554,236],[552,234],[552,233],[550,232],[549,230],[548,229],[546,227],[546,226],[545,225],[543,224],[544,223],[545,223],[545,220],[546,219],[548,218],[548,219],[550,221],[551,221],[551,220],[553,221],[554,221],[556,221],[556,221],[558,220],[558,219],[559,219],[561,220],[563,220],[564,218],[565,216],[565,214],[564,213],[566,213],[566,213],[567,213],[567,215],[568,217],[569,218],[569,219],[569,221]]
      ],
      countryCenter: { x: 558, y: 226 },
      countryCode: 'SSD',
      countryId: 156,
      countryName: 'S. Sudan',
    },
    159: {
      countryBorder: [
        [[570,221],[569,221],[569,219],[569,218],[568,217],[567,215],[567,213],[566,213],[566,213],[564,213],[565,214],[565,216],[564,218],[563,220],[561,220],[559,219],[558,219],[558,220],[556,221],[556,221],[554,221],[553,221],[551,220],[551,221],[550,221],[548,219],[548,218],[546,219],[545,220],[545,223],[544,223],[543,224],[543,223],[542,223],[542,222],[542,220],[542,219],[540,217],[540,216],[540,215],[539,214],[539,213],[538,211],[538,212],[538,210],[538,209],[538,208],[539,207],[538,206],[539,204],[540,202],[542,202],[542,191],[542,189],[545,189],[545,183],[555,183],[565,183],[576,183],[577,186],[576,187],[577,190],[578,193],[579,194],[580,195],[579,197],[577,197],[576,198],[576,200],[575,205],[576,206],[575,209],[574,212],[573,213],[572,215],[572,217],[570,217],[570,221]]
      ],
      countryCenter: { x: 559, y: 203.5 },
      countryCode: 'SDN',
      countryId: 159,
      countryName: 'Sudan',
    },
  },
  2015: {
    63: {
      countryBorder: [
        [[581,124],[581,123],[580.5, 122],[582.6,119.4],[585,121],[586,121],[587,121],[590,121],[591,123],[592,123],[592,124],[593,125],[593,126],[592,126],[590,125],[589,125],[586,126],[583,124]],
      ],
      countryCenter: { x: 584.5, y: 122 },
      countryCode: 'GEO',
      countryId: 63,
      countryName: 'Georgia',
      labelCenter: { x: 586, y: 122.8 },
    },
    224: {
      countryBorder:[[
        [580.5, 122],[580,121],[578,120],[577,120],[576,119],[576,118],[578,119],[582,119],[582.6,119.4]]
      ],
      countryCenter: { x: 579, y: 120 },
      countryCode: 'ABK',
      countryId: 224,
      countryName: 'Abkhazia',
    }
  }
}

export default WorldBorderList
